(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('jquery')) :
	typeof define === 'function' && define.amd ? define(['exports', 'jquery'], factory) :
	(factory((global.illustratorPlacer = {}),global.$));
}(this, (function (exports,$) { 'use strict';

	$ = $ && $.hasOwnProperty('default') ? $['default'] : $;

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var defineProperty = createCommonjsModule(function (module) {
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _defineProperty = unwrapExports(defineProperty);

	var asyncToGenerator = createCommonjsModule(function (module) {
	function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
	  try {
	    var info = gen[key](arg);
	    var value = info.value;
	  } catch (error) {
	    reject(error);
	    return;
	  }

	  if (info.done) {
	    resolve(value);
	  } else {
	    Promise.resolve(value).then(_next, _throw);
	  }
	}

	function _asyncToGenerator(fn) {
	  return function () {
	    var self = this,
	        args = arguments;
	    return new Promise(function (resolve, reject) {
	      var gen = fn.apply(self, args);

	      function _next(value) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
	      }

	      function _throw(err) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
	      }

	      _next(undefined);
	    });
	  };
	}

	module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _asyncToGenerator = unwrapExports(asyncToGenerator);

	var runtime_1 = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var runtime = (function (exports) {

	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  function define(obj, key, value) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	    return obj[key];
	  }
	  try {
	    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	    define({}, "");
	  } catch (err) {
	    define = function(obj, key, value) {
	      return obj[key] = value;
	    };
	  }

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  exports.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });

	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }

	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = GeneratorFunctionPrototype;
	  define(Gp, "constructor", GeneratorFunctionPrototype);
	  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
	  GeneratorFunction.displayName = define(
	    GeneratorFunctionPrototype,
	    toStringTagSymbol,
	    "GeneratorFunction"
	  );

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      define(prototype, method, function(arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }

	  exports.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  exports.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      define(genFun, toStringTagSymbol, "GeneratorFunction");
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function(arg) {
	    return { __await: arg };
	  };

	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return PromiseImpl.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function(error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);
	  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  });
	  exports.AsyncIterator = AsyncIterator;

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;

	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList),
	      PromiseImpl
	    );

	    return exports.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      context.method = method;
	      context.arg = arg;

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }

	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;

	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }

	          context.dispatchException(context.arg);

	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          if (record.arg === ContinueSentinel) {
	            continue;
	          }

	          return {
	            value: record.arg,
	            done: context.done
	          };

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }

	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;

	      if (context.method === "throw") {
	        // Note: ["return"] must be used for ES3 parsing compatibility.
	        if (delegate.iterator["return"]) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);

	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }

	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }

	      return ContinueSentinel;
	    }

	    var record = tryCatch(method, delegate.iterator, context.arg);

	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    var info = record.arg;

	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;

	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;

	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }

	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }

	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  define(Gp, toStringTagSymbol, "Generator");

	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  define(Gp, iteratorSymbol, function() {
	    return this;
	  });

	  define(Gp, "toString", function() {
	    return "[object Generator]";
	  });

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  exports.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  exports.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.method = "next";
	      this.arg = undefined;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;

	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }

	        return !! caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }

	      return this.complete(record);
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }

	      return ContinueSentinel;
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }

	      return ContinueSentinel;
	    }
	  };

	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;

	}(
	  // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	  module.exports
	));

	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, in modern engines
	  // we can explicitly access globalThis. In older engines we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}
	});

	var regenerator = runtime_1;

	var _typeof_1 = createCommonjsModule(function (module) {
	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}

	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});

	var _typeof = unwrapExports(_typeof_1);

	function loadCSInterface() {
	  /**************************************************************************************************
	  *
	  * ADOBE SYSTEMS INCORPORATED
	  * Copyright 2013 Adobe Systems Incorporated
	  * All Rights Reserved.
	  *
	  * NOTICE:  Adobe permits you to use, modify, and distribute this file in accordance with the
	  * terms of the Adobe license agreement accompanying it.  If you have received this file from a
	  * source other than Adobe, then your use, modification, or distribution of it requires the prior
	  * written permission of Adobe.
	  *
	  **************************************************************************************************/

	  /** CSInterface - v9.4.0 */

	  /**
	   * Stores constants for the window types supported by the CSXS infrastructure.
	   */
	  function CSXSWindowType() {}
	  /** Constant for the CSXS window type Panel. */


	  CSXSWindowType._PANEL = "Panel";
	  /** Constant for the CSXS window type Modeless. */

	  CSXSWindowType._MODELESS = "Modeless";
	  /** Constant for the CSXS window type ModalDialog. */

	  CSXSWindowType._MODAL_DIALOG = "ModalDialog";
	  /** EvalScript error message */

	  var EvalScript_ErrMessage = "EvalScript error.";
	  window.CSXSWindowType = CSXSWindowType;
	  window.EvalScript_ErrMessage = EvalScript_ErrMessage;
	  /**
	   * @class MenuItemStatus
	   * Stores flyout menu item status
	   *
	   * Since 5.2.0
	   *
	   * @param menuItemLabel  The menu item label.
	   * @param enabled        True if user wants to enable the menu item.
	   * @param checked        True if user wants to check the menu item.
	   *
	   * @return MenuItemStatus object.
	   */


	  function MenuItemStatus(menuItemLabel, enabled, checked) {
	    this.menuItemLabel = menuItemLabel;
	    this.enabled = enabled;
	    this.checked = checked;
	  }
	  /**
	   * @class ContextMenuItemStatus
	   * Stores the status of the context menu item.
	   *
	   * Since 5.2.0
	   *
	   * @param menuItemID     The menu item id.
	   * @param enabled        True if user wants to enable the menu item.
	   * @param checked        True if user wants to check the menu item.
	   *
	   * @return MenuItemStatus object.
	   */


	  function ContextMenuItemStatus(menuItemID, enabled, checked) {
	    this.menuItemID = menuItemID;
	    this.enabled = enabled;
	    this.checked = checked;
	  } //------------------------------ CSInterface ----------------------------------

	  /**
	   * @class CSInterface
	   * This is the entry point to the CEP extensibility infrastructure.
	   * Instantiate this object and use it to:
	   * <ul>
	   * <li>Access information about the host application in which an extension is running</li>
	   * <li>Launch an extension</li>
	   * <li>Register interest in event notifications, and dispatch events</li>
	   * </ul>
	   *
	   * @return A new \c CSInterface object
	   */


	  function CSInterface() {}
	  /**
	   * User can add this event listener to handle native application theme color changes.
	   * Callback function gives extensions ability to fine-tune their theme color after the
	   * global theme color has been changed.
	   * The callback function should be like below:
	   *
	   * @example
	   * // event is a CSEvent object, but user can ignore it.
	   * function OnAppThemeColorChanged(event)
	   * {
	   *    // Should get a latest HostEnvironment object from application.
	   *    var skinInfo = JSON.parse(window.__adobe_cep__.getHostEnvironment()).appSkinInfo;
	   *    // Gets the style information such as color info from the skinInfo,
	   *    // and redraw all UI controls of your extension according to the style info.
	   * }
	   */


	  CSInterface.THEME_COLOR_CHANGED_EVENT = "com.adobe.csxs.events.ThemeColorChanged";
	  /** The host environment data object. */

	  CSInterface.prototype.hostEnvironment = window.__adobe_cep__ ? JSON.parse(window.__adobe_cep__.getHostEnvironment()) : null;
	  /** Retrieves information about the host environment in which the
	   *  extension is currently running.
	   *
	   *   @return A \c #HostEnvironment object.
	   */

	  CSInterface.prototype.getHostEnvironment = function () {
	    this.hostEnvironment = JSON.parse(window.__adobe_cep__.getHostEnvironment());
	    return this.hostEnvironment;
	  };
	  /** Loads binary file created which is located at url asynchronously
	  *
	  *@param urlName url at which binary file is located. Local files should start with 'file://'
	  *@param callback Optional. A callback function that returns after binary is loaded
	   *@example
	  * To create JS binary use command ./cep_compiler test.js test.bin
	  * To load JS binary asyncronously
	  *   var CSLib = new CSInterface();
	  *   CSLib.loadBinAsync(url, function () { });
	  */


	  CSInterface.prototype.loadBinAsync = function (urlName, callback) {
	    try {
	      var xhr = new XMLHttpRequest();
	      xhr.responseType = 'arraybuffer'; // make response as ArrayBuffer

	      xhr.open('GET', urlName, true);

	      xhr.onerror = function () {
	        console.log("Unable to load snapshot from given URL");
	        return false;
	      };

	      xhr.send();

	      xhr.onload = function () {
	        window.__adobe_cep__.loadSnapshot(xhr.response);

	        if (typeof callback === "function") {
	          callback();
	        } else if (typeof callback !== "undefined") {
	          console.log("Provided callback is not a function");
	        }
	      };
	    } catch (err) {
	      console.log(err);
	      return false;
	    }

	    return true;
	  };
	  /** Loads binary file created synchronously
	  *
	  *@param pathName the local path at which binary file is located
	   *@example
	  * To create JS binary use command ./cep_compiler test.js test.bin
	  * To load JS binary syncronously
	  *   var CSLib = new CSInterface();
	  *   CSLib.loadBinSync(path);
	  */


	  CSInterface.prototype.loadBinSync = function (pathName) {
	    try {
	      var OSVersion = this.getOSInformation();

	      if (pathName.startsWith("file://")) {
	        if (OSVersion.indexOf("Windows") >= 0) {
	          pathName = pathName.replace("file:///", "");
	        } else if (OSVersion.indexOf("Mac") >= 0) {
	          pathName = pathName.replace("file://", "");
	        }

	        window.__adobe_cep__.loadSnapshot(pathName);

	        return true;
	      }
	    } catch (err) {
	      console.log(err);
	      return false;
	    } //control should not come here


	    return false;
	  };
	  /** Closes this extension. */


	  CSInterface.prototype.closeExtension = function () {
	    window.__adobe_cep__.closeExtension();
	  };
	  /**
	   * Retrieves a path for which a constant is defined in the system.
	   *
	   * @param pathType The path-type constant defined in \c #SystemPath ,
	   *
	   * @return The platform-specific system path string.
	   */


	  CSInterface.prototype.getSystemPath = function (pathType) {
	    var path = decodeURI(window.__adobe_cep__.getSystemPath(pathType));
	    var OSVersion = this.getOSInformation();

	    if (OSVersion.indexOf("Windows") >= 0) {
	      path = path.replace("file:///", "");
	    } else if (OSVersion.indexOf("Mac") >= 0) {
	      path = path.replace("file://", "");
	    }

	    return path;
	  };
	  /**
	   * Evaluates a JavaScript script, which can use the JavaScript DOM
	   * of the host application.
	   *
	   * @param script    The JavaScript script.
	   * @param callback  Optional. A callback function that receives the result of execution.
	   *          If execution fails, the callback function receives the error message \c EvalScript_ErrMessage.
	   */


	  CSInterface.prototype.evalScript = function (script, callback) {
	    if (callback === null || callback === undefined) {
	      callback = function callback(result) {};
	    }

	    window.__adobe_cep__.evalScript(script, callback);
	  };
	  /**
	   * Retrieves the unique identifier of the application.
	   * in which the extension is currently running.
	   *
	   * @return The unique ID string.
	   */


	  CSInterface.prototype.getApplicationID = function () {
	    var appId = this.hostEnvironment.appId;
	    return appId;
	  };
	  /**
	   * Retrieves host capability information for the application
	   * in which the extension is currently running.
	   *
	   * @return A \c #HostCapabilities object.
	   */


	  CSInterface.prototype.getHostCapabilities = function () {
	    var hostCapabilities = JSON.parse(window.__adobe_cep__.getHostCapabilities());
	    return hostCapabilities;
	  };
	  /**
	   * Triggers a CEP event programmatically. Yoy can use it to dispatch
	   * an event of a predefined type, or of a type you have defined.
	   *
	   * @param event A \c CSEvent object.
	   */


	  CSInterface.prototype.dispatchEvent = function (event) {
	    if (_typeof(event.data) == "object") {
	      event.data = JSON.stringify(event.data);
	    }

	    window.__adobe_cep__.dispatchEvent(event);
	  };
	  /**
	   * Registers an interest in a CEP event of a particular type, and
	   * assigns an event handler.
	   * The event infrastructure notifies your extension when events of this type occur,
	   * passing the event object to the registered handler function.
	   *
	   * @param type     The name of the event type of interest.
	   * @param listener The JavaScript handler function or method.
	   * @param obj      Optional, the object containing the handler method, if any.
	   *         Default is null.
	   */


	  CSInterface.prototype.addEventListener = function (type, listener, obj) {
	    window.__adobe_cep__.addEventListener(type, listener, obj);
	  };
	  /**
	   * Removes a registered event listener.
	   *
	   * @param type      The name of the event type of interest.
	   * @param listener  The JavaScript handler function or method that was registered.
	   * @param obj       Optional, the object containing the handler method, if any.
	   *          Default is null.
	   */


	  CSInterface.prototype.removeEventListener = function (type, listener, obj) {
	    window.__adobe_cep__.removeEventListener(type, listener, obj);
	  };
	  /**
	   * Loads and launches another extension, or activates the extension if it is already loaded.
	   *
	   * @param extensionId       The extension's unique identifier.
	   * @param startupParams     Not currently used, pass "".
	   *
	   * @example
	   * To launch the extension "help" with ID "HLP" from this extension, call:
	   * <code>requestOpenExtension("HLP", ""); </code>
	   *
	   */


	  CSInterface.prototype.requestOpenExtension = function (extensionId, params) {
	    window.__adobe_cep__.requestOpenExtension(extensionId, params);
	  };
	  /**
	   * Retrieves the list of extensions currently loaded in the current host application.
	   * The extension list is initialized once, and remains the same during the lifetime
	   * of the CEP session.
	   *
	   * @param extensionIds  Optional, an array of unique identifiers for extensions of interest.
	   *          If omitted, retrieves data for all extensions.
	   *
	   * @return Zero or more \c #Extension objects.
	   */


	  CSInterface.prototype.getExtensions = function (extensionIds) {
	    var extensionIdsStr = JSON.stringify(extensionIds);

	    var extensionsStr = window.__adobe_cep__.getExtensions(extensionIdsStr);

	    var extensions = JSON.parse(extensionsStr);
	    return extensions;
	  };
	  /**
	   * Retrieves network-related preferences.
	   *
	   * @return A JavaScript object containing network preferences.
	   */


	  CSInterface.prototype.getNetworkPreferences = function () {
	    var result = window.__adobe_cep__.getNetworkPreferences();

	    var networkPre = JSON.parse(result);
	    return networkPre;
	  };
	  /**
	   * Initializes the resource bundle for this extension with property values
	   * for the current application and locale.
	   * To support multiple locales, you must define a property file for each locale,
	   * containing keyed display-string values for that locale.
	   * See localization documentation for Extension Builder and related products.
	   *
	   * Keys can be in the
	   * form <code>key.value="localized string"</code>, for use in HTML text elements.
	   * For example, in this input element, the localized \c key.value string is displayed
	   * instead of the empty \c value string:
	   *
	   * <code><input type="submit" value="" data-locale="key"/></code>
	   *
	   * @return An object containing the resource bundle information.
	   */


	  CSInterface.prototype.initResourceBundle = function () {
	    var resourceBundle = JSON.parse(window.__adobe_cep__.initResourceBundle());
	    var resElms = document.querySelectorAll('[data-locale]');

	    for (var n = 0; n < resElms.length; n++) {
	      var resEl = resElms[n]; // Get the resource key from the element.

	      var resKey = resEl.getAttribute('data-locale');

	      if (resKey) {
	        // Get all the resources that start with the key.
	        for (var key in resourceBundle) {
	          if (key.indexOf(resKey) === 0) {
	            var resValue = resourceBundle[key];

	            if (key.length == resKey.length) {
	              resEl.innerHTML = resValue;
	            } else if ('.' == key.charAt(resKey.length)) {
	              var attrKey = key.substring(resKey.length + 1);
	              resEl[attrKey] = resValue;
	            }
	          }
	        }
	      }
	    }

	    return resourceBundle;
	  };
	  /**
	   * Writes installation information to a file.
	   *
	   * @return The file path.
	   */


	  CSInterface.prototype.dumpInstallationInfo = function () {
	    return window.__adobe_cep__.dumpInstallationInfo();
	  };
	  /**
	   * Retrieves version information for the current Operating System,
	   * See http://www.useragentstring.com/pages/Chrome/ for Chrome \c navigator.userAgent values.
	   *
	   * @return A string containing the OS version, or "unknown Operation System".
	   * If user customizes the User Agent by setting CEF command parameter "--user-agent", only
	   * "Mac OS X" or "Windows" will be returned.
	   */


	  CSInterface.prototype.getOSInformation = function () {
	    var userAgent = navigator.userAgent;

	    if (navigator.platform == "Win32" || navigator.platform == "Windows") {
	      var winVersion = "Windows";
	      var winBit = "";

	      if (userAgent.indexOf("Windows") > -1) {
	        if (userAgent.indexOf("Windows NT 5.0") > -1) {
	          winVersion = "Windows 2000";
	        } else if (userAgent.indexOf("Windows NT 5.1") > -1) {
	          winVersion = "Windows XP";
	        } else if (userAgent.indexOf("Windows NT 5.2") > -1) {
	          winVersion = "Windows Server 2003";
	        } else if (userAgent.indexOf("Windows NT 6.0") > -1) {
	          winVersion = "Windows Vista";
	        } else if (userAgent.indexOf("Windows NT 6.1") > -1) {
	          winVersion = "Windows 7";
	        } else if (userAgent.indexOf("Windows NT 6.2") > -1) {
	          winVersion = "Windows 8";
	        } else if (userAgent.indexOf("Windows NT 6.3") > -1) {
	          winVersion = "Windows 8.1";
	        } else if (userAgent.indexOf("Windows NT 10") > -1) {
	          winVersion = "Windows 10";
	        }

	        if (userAgent.indexOf("WOW64") > -1 || userAgent.indexOf("Win64") > -1) {
	          winBit = " 64-bit";
	        } else {
	          winBit = " 32-bit";
	        }
	      }

	      return winVersion + winBit;
	    } else if (navigator.platform == "MacIntel" || navigator.platform == "Macintosh") {
	      var result = "Mac OS X";

	      if (userAgent.indexOf("Mac OS X") > -1) {
	        result = userAgent.substring(userAgent.indexOf("Mac OS X"), userAgent.indexOf(")"));
	        result = result.replace(/_/g, ".");
	      }

	      return result;
	    }

	    return "Unknown Operation System";
	  };
	  /**
	   * Opens a page in the default system browser.
	   *
	   * Since 4.2.0
	   *
	   * @param url  The URL of the page/file to open, or the email address.
	   * Must use HTTP/HTTPS/file/mailto protocol. For example:
	   *   "http://www.adobe.com"
	   *   "https://github.com"
	   *   "file:///C:/log.txt"
	   *   "mailto:test@adobe.com"
	   *
	   * @return One of these error codes:\n
	   *      <ul>\n
	   *          <li>NO_ERROR - 0</li>\n
	   *          <li>ERR_UNKNOWN - 1</li>\n
	   *          <li>ERR_INVALID_PARAMS - 2</li>\n
	   *          <li>ERR_INVALID_URL - 201</li>\n
	   *      </ul>\n
	   */


	  CSInterface.prototype.openURLInDefaultBrowser = function (url) {
	    return cep.util.openURLInDefaultBrowser(url);
	  };
	  /**
	   * Retrieves extension ID.
	   *
	   * Since 4.2.0
	   *
	   * @return extension ID.
	   */


	  CSInterface.prototype.getExtensionID = function () {
	    return window.__adobe_cep__.getExtensionId();
	  };
	  /**
	   * Retrieves the scale factor of screen.
	   * On Windows platform, the value of scale factor might be different from operating system's scale factor,
	   * since host application may use its self-defined scale factor.
	   *
	   * Since 4.2.0
	   *
	   * @return One of the following float number.
	   *      <ul>\n
	   *          <li> -1.0 when error occurs </li>\n
	   *          <li> 1.0 means normal screen </li>\n
	   *          <li> >1.0 means HiDPI screen </li>\n
	   *      </ul>\n
	   */


	  CSInterface.prototype.getScaleFactor = function () {
	    return window.__adobe_cep__.getScaleFactor();
	  };
	  /**
	   * Retrieves the scale factor of Monitor.
	   *
	   * Since 8.5.0
	   *
	   * @return value >= 1.0f
	   * only available for windows machine
	   */


	  if (navigator.appVersion.toLowerCase().indexOf("windows") >= 0) {
	    CSInterface.prototype.getMonitorScaleFactor = function () {
	      return window.__adobe_cep__.getMonitorScaleFactor();
	    };
	  }
	  /**
	   * Set a handler to detect any changes of scale factor. This only works on Mac.
	   *
	   * Since 4.2.0
	   *
	   * @param handler   The function to be called when scale factor is changed.
	   *
	   */


	  CSInterface.prototype.setScaleFactorChangedHandler = function (handler) {
	    window.__adobe_cep__.setScaleFactorChangedHandler(handler);
	  };
	  /**
	   * Retrieves current API version.
	   *
	   * Since 4.2.0
	   *
	   * @return ApiVersion object.
	   *
	   */


	  CSInterface.prototype.getCurrentApiVersion = function () {
	    var apiVersion = JSON.parse(window.__adobe_cep__.getCurrentApiVersion());
	    return apiVersion;
	  };
	  /**
	   * Set panel flyout menu by an XML.
	   *
	   * Since 5.2.0
	   *
	   * Register a callback function for "com.adobe.csxs.events.flyoutMenuClicked" to get notified when a
	   * menu item is clicked.
	   * The "data" attribute of event is an object which contains "menuId" and "menuName" attributes.
	   *
	   * Register callback functions for "com.adobe.csxs.events.flyoutMenuOpened" and "com.adobe.csxs.events.flyoutMenuClosed"
	   * respectively to get notified when flyout menu is opened or closed.
	   *
	   * @param menu     A XML string which describes menu structure.
	   * An example menu XML:
	   * <Menu>
	   *   <MenuItem Id="menuItemId1" Label="TestExample1" Enabled="true" Checked="false"/>
	   *   <MenuItem Label="TestExample2">
	   *     <MenuItem Label="TestExample2-1" >
	   *       <MenuItem Label="TestExample2-1-1" Enabled="false" Checked="true"/>
	   *     </MenuItem>
	   *     <MenuItem Label="TestExample2-2" Enabled="true" Checked="true"/>
	   *   </MenuItem>
	   *   <MenuItem Label="---" />
	   *   <MenuItem Label="TestExample3" Enabled="false" Checked="false"/>
	   * </Menu>
	   *
	   */


	  CSInterface.prototype.setPanelFlyoutMenu = function (menu) {
	    if ("string" != typeof menu) {
	      return;
	    }

	    window.__adobe_cep__.invokeSync("setPanelFlyoutMenu", menu);
	  };
	  /**
	   * Updates a menu item in the extension window's flyout menu, by setting the enabled
	   * and selection status.
	   *
	   * Since 5.2.0
	   *
	   * @param menuItemLabel The menu item label.
	   * @param enabled       True to enable the item, false to disable it (gray it out).
	   * @param checked       True to select the item, false to deselect it.
	   *
	   * @return false when the host application does not support this functionality (HostCapabilities.EXTENDED_PANEL_MENU is false).
	   *         Fails silently if menu label is invalid.
	   *
	   * @see HostCapabilities.EXTENDED_PANEL_MENU
	   */


	  CSInterface.prototype.updatePanelMenuItem = function (menuItemLabel, enabled, checked) {
	    var ret = false;

	    if (this.getHostCapabilities().EXTENDED_PANEL_MENU) {
	      var itemStatus = new MenuItemStatus(menuItemLabel, enabled, checked);
	      ret = window.__adobe_cep__.invokeSync("updatePanelMenuItem", JSON.stringify(itemStatus));
	    }

	    return ret;
	  };
	  /**
	   * Set context menu by XML string.
	   *
	   * Since 5.2.0
	   *
	   * There are a number of conventions used to communicate what type of menu item to create and how it should be handled.
	   * - an item without menu ID or menu name is disabled and is not shown.
	   * - if the item name is "---" (three hyphens) then it is treated as a separator. The menu ID in this case will always be NULL.
	   * - Checkable attribute takes precedence over Checked attribute.
	   * - a PNG icon. For optimal display results please supply a 16 x 16px icon as larger dimensions will increase the size of the menu item.
	       The Chrome extension contextMenus API was taken as a reference.
	       https://developer.chrome.com/extensions/contextMenus
	   * - the items with icons and checkable items cannot coexist on the same menu level. The former take precedences over the latter.
	   *
	   * @param menu      A XML string which describes menu structure.
	   * @param callback  The callback function which is called when a menu item is clicked. The only parameter is the returned ID of clicked menu item.
	   *
	   * @description An example menu XML:
	   * <Menu>
	   *   <MenuItem Id="menuItemId1" Label="TestExample1" Enabled="true" Checkable="true" Checked="false" Icon="./image/small_16X16.png"/>
	   *   <MenuItem Id="menuItemId2" Label="TestExample2">
	   *     <MenuItem Id="menuItemId2-1" Label="TestExample2-1" >
	   *       <MenuItem Id="menuItemId2-1-1" Label="TestExample2-1-1" Enabled="false" Checkable="true" Checked="true"/>
	   *     </MenuItem>
	   *     <MenuItem Id="menuItemId2-2" Label="TestExample2-2" Enabled="true" Checkable="true" Checked="true"/>
	   *   </MenuItem>
	   *   <MenuItem Label="---" />
	   *   <MenuItem Id="menuItemId3" Label="TestExample3" Enabled="false" Checkable="true" Checked="false"/>
	   * </Menu>
	   */


	  CSInterface.prototype.setContextMenu = function (menu, callback) {
	    if ("string" != typeof menu) {
	      return;
	    }

	    window.__adobe_cep__.invokeAsync("setContextMenu", menu, callback);
	  };
	  /**
	   * Set context menu by JSON string.
	   *
	   * Since 6.0.0
	   *
	   * There are a number of conventions used to communicate what type of menu item to create and how it should be handled.
	   * - an item without menu ID or menu name is disabled and is not shown.
	   * - if the item label is "---" (three hyphens) then it is treated as a separator. The menu ID in this case will always be NULL.
	   * - Checkable attribute takes precedence over Checked attribute.
	   * - a PNG icon. For optimal display results please supply a 16 x 16px icon as larger dimensions will increase the size of the menu item.
	       The Chrome extension contextMenus API was taken as a reference.
	   * - the items with icons and checkable items cannot coexist on the same menu level. The former take precedences over the latter.
	       https://developer.chrome.com/extensions/contextMenus
	   *
	   * @param menu      A JSON string which describes menu structure.
	   * @param callback  The callback function which is called when a menu item is clicked. The only parameter is the returned ID of clicked menu item.
	   *
	   * @description An example menu JSON:
	   *
	   * {
	   *      "menu": [
	   *          {
	   *              "id": "menuItemId1",
	   *              "label": "testExample1",
	   *              "enabled": true,
	   *              "checkable": true,
	   *              "checked": false,
	   *              "icon": "./image/small_16X16.png"
	   *          },
	   *          {
	   *              "id": "menuItemId2",
	   *              "label": "testExample2",
	   *              "menu": [
	   *                  {
	   *                      "id": "menuItemId2-1",
	   *                      "label": "testExample2-1",
	   *                      "menu": [
	   *                          {
	   *                              "id": "menuItemId2-1-1",
	   *                              "label": "testExample2-1-1",
	   *                              "enabled": false,
	   *                              "checkable": true,
	   *                              "checked": true
	   *                          }
	   *                      ]
	   *                  },
	   *                  {
	   *                      "id": "menuItemId2-2",
	   *                      "label": "testExample2-2",
	   *                      "enabled": true,
	   *                      "checkable": true,
	   *                      "checked": true
	   *                  }
	   *              ]
	   *          },
	   *          {
	   *              "label": "---"
	   *          },
	   *          {
	   *              "id": "menuItemId3",
	   *              "label": "testExample3",
	   *              "enabled": false,
	   *              "checkable": true,
	   *              "checked": false
	   *          }
	   *      ]
	   *  }
	   *
	   */


	  CSInterface.prototype.setContextMenuByJSON = function (menu, callback) {
	    if ("string" != typeof menu) {
	      return;
	    }

	    window.__adobe_cep__.invokeAsync("setContextMenuByJSON", menu, callback);
	  };
	  /**
	   * Updates a context menu item by setting the enabled and selection status.
	   *
	   * Since 5.2.0
	   *
	   * @param menuItemID    The menu item ID.
	   * @param enabled       True to enable the item, false to disable it (gray it out).
	   * @param checked       True to select the item, false to deselect it.
	   */


	  CSInterface.prototype.updateContextMenuItem = function (menuItemID, enabled, checked) {
	    var itemStatus = new ContextMenuItemStatus(menuItemID, enabled, checked);
	    ret = window.__adobe_cep__.invokeSync("updateContextMenuItem", JSON.stringify(itemStatus));
	  };
	  /**
	   * Get the visibility status of an extension window.
	   *
	   * Since 6.0.0
	   *
	   * @return true if the extension window is visible; false if the extension window is hidden.
	   */


	  CSInterface.prototype.isWindowVisible = function () {
	    return window.__adobe_cep__.invokeSync("isWindowVisible", "");
	  };
	  /**
	   * Resize extension's content to the specified dimensions.
	   * 1. Works with modal and modeless extensions in all Adobe products.
	   * 2. Extension's manifest min/max size constraints apply and take precedence.
	   * 3. For panel extensions
	   *    3.1 This works in all Adobe products except:
	   *        * Premiere Pro
	   *        * Prelude
	   *        * After Effects
	   *    3.2 When the panel is in certain states (especially when being docked),
	   *        it will not change to the desired dimensions even when the
	   *        specified size satisfies min/max constraints.
	   *
	   * Since 6.0.0
	   *
	   * @param width  The new width
	   * @param height The new height
	   */


	  CSInterface.prototype.resizeContent = function (width, height) {
	    window.__adobe_cep__.resizeContent(width, height);
	  };
	  /**
	   * Register the invalid certificate callback for an extension.
	   * This callback will be triggered when the extension tries to access the web site that contains the invalid certificate on the main frame.
	   * But if the extension does not call this function and tries to access the web site containing the invalid certificate, a default error page will be shown.
	   *
	   * Since 6.1.0
	   *
	   * @param callback the callback function
	   */


	  CSInterface.prototype.registerInvalidCertificateCallback = function (callback) {
	    return window.__adobe_cep__.registerInvalidCertificateCallback(callback);
	  };
	  /**
	   * Register an interest in some key events to prevent them from being sent to the host application.
	   *
	   * This function works with modeless extensions and panel extensions.
	   * Generally all the key events will be sent to the host application for these two extensions if the current focused element
	   * is not text input or dropdown,
	   * If you want to intercept some key events and want them to be handled in the extension, please call this function
	   * in advance to prevent them being sent to the host application.
	   *
	   * Since 6.1.0
	   *
	   * @param keyEventsInterest      A JSON string describing those key events you are interested in. A null object or
	                                   an empty string will lead to removing the interest
	   *
	   * This JSON string should be an array, each object has following keys:
	   *
	   * keyCode:  [Required] represents an OS system dependent virtual key code identifying
	   *           the unmodified value of the pressed key.
	   * ctrlKey:  [optional] a Boolean that indicates if the control key was pressed (true) or not (false) when the event occurred.
	   * altKey:   [optional] a Boolean that indicates if the alt key was pressed (true) or not (false) when the event occurred.
	   * shiftKey: [optional] a Boolean that indicates if the shift key was pressed (true) or not (false) when the event occurred.
	   * metaKey:  [optional] (Mac Only) a Boolean that indicates if the Meta key was pressed (true) or not (false) when the event occurred.
	   *                      On Macintosh keyboards, this is the command key. To detect Windows key on Windows, please use keyCode instead.
	   * An example JSON string:
	   *
	   * [
	   *     {
	   *         "keyCode": 48
	   *     },
	   *     {
	   *         "keyCode": 123,
	   *         "ctrlKey": true
	   *     },
	   *     {
	   *         "keyCode": 123,
	   *         "ctrlKey": true,
	   *         "metaKey": true
	   *     }
	   * ]
	   *
	   */


	  CSInterface.prototype.registerKeyEventsInterest = function (keyEventsInterest) {
	    return window.__adobe_cep__.registerKeyEventsInterest(keyEventsInterest);
	  };
	  /**
	   * Set the title of the extension window.
	   * This function works with modal and modeless extensions in all Adobe products, and panel extensions in Photoshop, InDesign, InCopy, Illustrator, Flash Pro and Dreamweaver.
	   *
	   * Since 6.1.0
	   *
	   * @param title The window title.
	   */


	  CSInterface.prototype.setWindowTitle = function (title) {
	    window.__adobe_cep__.invokeSync("setWindowTitle", title);
	  };
	  /**
	   * Get the title of the extension window.
	   * This function works with modal and modeless extensions in all Adobe products, and panel extensions in Photoshop, InDesign, InCopy, Illustrator, Flash Pro and Dreamweaver.
	   *
	   * Since 6.1.0
	   *
	   * @return The window title.
	   */


	  CSInterface.prototype.getWindowTitle = function () {
	    return window.__adobe_cep__.invokeSync("getWindowTitle", "");
	  };

	  return CSInterface;
	}

	// We can use the Adobe CSLibrary to create a temporary folder and save the SVG file there
	// so that it can be placed in Illustrator.
	function saveSvg(data, name) {
	  var downloadedFile = createTempFolder() + name;
	  window.cep.fs.writeFile(downloadedFile, data);
	  return downloadedFile;
	}

	function createTempFolder() {
	  var tempFolderName = 'com.adobe.chartlos.extension/';
	  var tempFolder = '/tmp/' + tempFolderName;

	  if (window.navigator.platform.toLowerCase().indexOf('win') > -1) {
	    tempFolder = window.CSLibrary.getSystemPath(SystemPath.USER_DATA) + '/../Local/Temp/' + tempFolderName;
	  }

	  window.cep.fs.makedir(tempFolder);
	  return tempFolder;
	}

	var arrayPolyfills = "/* Polyfill service v3.25.1\n * For detailed credits and licence information see https://github.com/financial-times/polyfill-service.\n *\n * UA detected: safari/12.0.0\n * Features requested: modernizr:es5array\n *\n * - Object.defineProperty, License: CC0 (required by \"Array.isArray\", \"modernizr:es5array\")\n * - Array.isArray, License: CC0 (required by \"modernizr:es5array\")\n * - Array.prototype.every, License: CC0 (required by \"modernizr:es5array\")\n * - Array.prototype.filter, License: CC0 (required by \"modernizr:es5array\")\n * - Array.prototype.forEach, License: CC0 (required by \"modernizr:es5array\")\n * - Array.prototype.indexOf, License: CC0 (required by \"modernizr:es5array\")\n * - Array.prototype.lastIndexOf, License: CC0 (required by \"modernizr:es5array\")\n * - Array.prototype.map, License: CC0 (required by \"modernizr:es5array\")\n * - Array.prototype.reduce, License: CC0 (required by \"modernizr:es5array\")\n * - Array.prototype.reduceRight, License: CC0 (required by \"modernizr:es5array\")\n * - Array.prototype.some, License: CC0 (required by \"modernizr:es5array\") */\n\n(function(undefined) {\n\n// Object.defineProperty\n(function (nativeDefineProperty) {\n\n\tvar supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');\n\tvar ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';\n\tvar ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';\n\n\tObject.defineProperty = function defineProperty(object, property, descriptor) {\n\n\t\tif (object === null || !(object instanceof Object || typeof object === 'object')) {\n\t\t\tthrow new TypeError('Object.defineProperty called on non-object');\n\t\t}\n\n\t\tif (!(descriptor instanceof Object)) {\n\t\t\tthrow new TypeError('Property description must be an object');\n\t\t}\n\n\t\tvar propertyString = String(property);\n\t\tvar hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;\n\t\tvar getterType = 'get' in descriptor && typeof descriptor.get;\n\t\tvar setterType = 'set' in descriptor && typeof descriptor.set;\n\n\t\t// handle descriptor.get\n\t\tif (getterType) {\n\t\t\tif (getterType !== 'function') {\n\t\t\t\tthrow new TypeError('Getter must be a function');\n\t\t\t}\n\t\t\tif (!supportsAccessors) {\n\t\t\t\tthrow new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);\n\t\t\t}\n\t\t\tif (hasValueOrWritable) {\n\t\t\t\tthrow new TypeError(ERR_VALUE_ACCESSORS);\n\t\t\t}\n\t\t\tObject.__defineGetter__.call(object, propertyString, descriptor.get);\n\t\t} else {\n\t\t\tobject[propertyString] = descriptor.value;\n\t\t}\n\n\t\t// handle descriptor.set\n\t\tif (setterType) {\n\t\t\tif (setterType !== 'function') {\n\t\t\t\tthrow new TypeError('Setter must be a function');\n\t\t\t}\n\t\t\tif (!supportsAccessors) {\n\t\t\t\tthrow new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);\n\t\t\t}\n\t\t\tif (hasValueOrWritable) {\n\t\t\t\tthrow new TypeError(ERR_VALUE_ACCESSORS);\n\t\t\t}\n\t\t\tObject.__defineSetter__.call(object, propertyString, descriptor.set);\n\t\t}\n\n\t\t// OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above\n\t\tif ('value' in descriptor) {\n\t\t\tobject[propertyString] = descriptor.value;\n\t\t}\n\n\t\treturn object;\n\t};\n}(Object.defineProperty));\n\n// Array.isArray\n(function (toString) {\n\tObject.defineProperty(Array, 'isArray', {\n\t\tconfigurable: true,\n\t\tvalue: function isArray(object) {\n\t\t\treturn toString.call(object) === '[object Array]';\n\t\t},\n\t\twritable: true\n\t});\n}(Object.prototype.toString));\n\n// Array.prototype.every\nArray.prototype.every = function every(callback) {\n\tif (this === undefined || this === null) {\n\t\tthrow new TypeError(this + ' is not an object');\n\t}\n\n\tif (typeof callback !== 'function') {\n\t\tthrow new TypeError(callback + ' is not a function');\n\t}\n\n\tvar\n\tobject = Object(this),\n\tscope = arguments[1],\n\tarraylike = object instanceof String ? object.split('') : object,\n\tlength = Number(arraylike.length) || 0,\n\tindex = -1;\n\n\twhile (++index < length) {\n\t\tif (index in arraylike && !callback.call(scope, arraylike[index], index, object)) {\n\t\t\treturn false;\n\t\t}\n\t}\n\n\treturn true;\n};\n\n// Array.prototype.filter\nArray.prototype.filter = function filter(callback) {\n\tif (this === undefined || this === null) {\n\t\tthrow new TypeError(this + ' is not an object');\n\t}\n\n\tif (typeof callback !== 'function') {\n\t\tthrow new TypeError(callback + ' is not a function');\n\t}\n\n\tvar\n\tobject = Object(this),\n\tscope = arguments[1],\n\tarraylike = object instanceof String ? object.split('') : object,\n\tlength = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,\n\tindex = -1,\n\tresult = [],\n\telement;\n\n\twhile (++index < length) {\n\t\telement = arraylike[index];\n\n\t\tif (index in arraylike && callback.call(scope, element, index, object)) {\n\t\t\tresult.push(element);\n\t\t}\n\t}\n\n\treturn result;\n};\n\n// Array.prototype.forEach\nArray.prototype.forEach = function forEach(callback) {\n\tif (this === undefined || this === null) {\n\t\tthrow new TypeError(this + ' is not an object');\n\t}\n\n\tif (typeof callback !== 'function') {\n\t\tthrow new TypeError(callback + ' is not a function');\n\t}\n\n\tvar\n\tobject = Object(this),\n\tscope = arguments[1],\n\tarraylike = object instanceof String ? object.split('') : object,\n\tlength = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,\n\tindex = -1;\n\n\twhile (++index < length) {\n\t\tif (index in arraylike) {\n\t\t\tcallback.call(scope, arraylike[index], index, object);\n\t\t}\n\t}\n};\n\n// Array.prototype.indexOf\nArray.prototype.indexOf = function indexOf(searchElement) {\n\tif (this === undefined || this === null) {\n\t\tthrow new TypeError(this + ' is not an object');\n\t}\n\n\tvar\n\tarraylike = this instanceof String ? this.split('') : this,\n\tlength = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,\n\tindex = Number(arguments[1]) || 0;\n\n\tindex = (index < 0 ? Math.max(length + index, 0) : index) - 1;\n\n\twhile (++index < length) {\n\t\tif (index in arraylike && arraylike[index] === searchElement) {\n\t\t\treturn index;\n\t\t}\n\t}\n\n\treturn -1;\n};\n\n// Array.prototype.lastIndexOf\nArray.prototype.lastIndexOf = function lastIndexOf(searchElement) {\n\tif (this === undefined || this === null) {\n\t\tthrow new TypeError(this + ' is not an object');\n\t}\n\n\tvar\n\tarraylike = this instanceof String ? this.split('') : this,\n\tlength = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,\n\tindex = Number(arguments[1]) || 0;\n\n\tindex = 1 in arguments ? (index < 0 ? Math.max(length + index, 0) : index) + 1 : length;\n\n\twhile (--index >= 0) {\n\t\tif (index in arraylike && arraylike[index] === searchElement) {\n\t\t\treturn index;\n\t\t}\n\t}\n\n\treturn -1;\n};\n\n// Array.prototype.map\nArray.prototype.map = function map(callback) {\n\tif (this === undefined || this === null) {\n\t\tthrow new TypeError(this + ' is not an object');\n\t}\n\n\tif (typeof callback !== 'function') {\n\t\tthrow new TypeError(callback + ' is not a function');\n\t}\n\n\tvar\n\tobject = Object(this),\n\tscope = arguments[1],\n\tarraylike = object instanceof String ? object.split('') : object,\n\tlength = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,\n\tindex = -1,\n\tresult = [];\n\n\twhile (++index < length) {\n\t\tif (index in arraylike) {\n\t\t\tresult[index] = callback.call(scope, arraylike[index], index, object);\n\t\t}\n\t}\n\n\treturn result;\n};\n\n// Array.prototype.reduce\nArray.prototype.reduce = function reduce(callback) {\n\tif (this === undefined || this === null) {\n\t\tthrow new TypeError(this + ' is not an object');\n\t}\n\n\tif (typeof callback !== 'function') {\n\t\tthrow new TypeError(callback + ' is not a function');\n\t}\n\n\tvar\n\tobject = Object(this),\n\tarraylike = object instanceof String ? object.split('') : object,\n\tlength = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,\n\tindex = -1,\n\tpreviousValue;\n\n\tif (1 in arguments) {\n\t\tpreviousValue = arguments[1];\n\t} else {\n\t\twhile (++index < length && !(index in arraylike)) {}\n\n\t\tif (index >= length) {\n\t\t\tthrow new TypeError('Reduce of empty array with no initial value');\n\t\t}\n\n\t\tpreviousValue = arraylike[index];\n\t}\n\n\twhile (++index < length) {\n\t\tif (index in arraylike) {\n\t\t\tpreviousValue = callback(previousValue, arraylike[index], index, object);\n\t\t}\n\t}\n\n\treturn previousValue;\n};\n\n// Array.prototype.reduceRight\nArray.prototype.reduceRight = function reduceRight(callback) {\n\tif (this === undefined || this === null) {\n\t\tthrow new TypeError(this + ' is not an object');\n\t}\n\n\tif (typeof callback !== 'function') {\n\t\tthrow new TypeError(callback + ' is not a function');\n\t}\n\n\tvar\n\tobject = Object(this),\n\tarraylike = object instanceof String ? object.split('') : object,\n\tlength = -1,\n\tindex = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,\n\tpreviousValue;\n\n\tif (1 in arguments) {\n\t\tpreviousValue = arguments[1];\n\t} else {\n\t\twhile (--index > length && !(index in arraylike)) {}\n\n\t\tif (index <= length) {\n\t\t\tthrow new TypeError('Reduce of empty array with no initial value');\n\t\t}\n\n\t\tpreviousValue = arraylike[index];\n\t}\n\n\twhile (--index > length) {\n\t\tif (index in arraylike) {\n\t\t\tpreviousValue = callback(previousValue, arraylike[index], index, object);\n\t\t}\n\t}\n\n\treturn previousValue;\n};\n\n// Array.prototype.some\nArray.prototype.some = function some(callback) {\n\tif (this === undefined || this === null) {\n\t\tthrow new TypeError(this + ' is not an object');\n\t}\n\n\tif (typeof callback !== 'function') {\n\t\tthrow new TypeError(callback + ' is not a function');\n\t}\n\n\tvar\n\tobject = Object(this),\n\tscope = arguments[1],\n\tarraylike = object instanceof String ? object.split('') : object,\n\tlength = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,\n\tindex = -1;\n\n\twhile (++index < length) {\n\t\tif (index in arraylike && callback.call(scope, arraylike[index], index, object)) {\n\t\t\treturn true;\n\t\t}\n\t}\n\n\treturn false;\n};\n\n// Production steps of ECMA-262, Edition 6, 22.1.2.1\nArray.from = function () {\n  var toStr = Object.prototype.toString;\n  var isCallable = function (fn) {\n    return typeof fn === 'function' || toStr.call(fn) === '[object Function]';\n  };\n  var toInteger = function (value) {\n    var number = Number(value);\n    if (isNaN(number)) { return 0; }\n    if (number === 0 || !isFinite(number)) { return number; }\n    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));\n  };\n  var maxSafeInteger = Math.pow(2, 53) - 1;\n  var toLength = function (value) {\n    var len = toInteger(value);\n    return Math.min(Math.max(len, 0), maxSafeInteger);\n  };\n\n  // The length property of the from method is 1.\n  return function from(arrayLike/*, mapFn, thisArg */) {\n    // 1. Let C be the this value.\n    var C = this;\n\n    // 2. Let items be ToObject(arrayLike).\n    var items = Object(arrayLike);\n\n    // 3. ReturnIfAbrupt(items).\n    if (arrayLike == null) {\n      throw new TypeError('Array.from requires an array-like object - not null or undefined');\n    }\n\n    // 4. If mapfn is undefined, then let mapping be false.\n    var mapFn = arguments.length > 1 ? arguments[1] : void undefined;\n    var T;\n    if (typeof mapFn !== 'undefined') {\n      // 5. else\n      // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.\n      if (!isCallable(mapFn)) {\n        throw new TypeError('Array.from: when provided, the second argument must be a function');\n      }\n\n      // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.\n      if (arguments.length > 2) {\n        T = arguments[2];\n      }\n    }\n\n    // 10. Let lenValue be Get(items, \"length\").\n    // 11. Let len be ToLength(lenValue).\n    var len = toLength(items.length);\n\n    // 13. If IsConstructor(C) is true, then\n    // 13. a. Let A be the result of calling the [[Construct]] internal method\n    // of C with an argument list containing the single item len.\n    // 14. a. Else, Let A be ArrayCreate(len).\n    var A = isCallable(C) ? Object(new C(len)) : new Array(len);\n\n    // 16. Let k be 0.\n    var k = 0;\n    // 17. Repeat, while k < len… (also steps a - h)\n    var kValue;\n    while (k < len) {\n      kValue = items[k];\n      if (mapFn) {\n        A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);\n      } else {\n        A[k] = kValue;\n      }\n      k += 1;\n    }\n    // 18. Let putStatus be Put(A, \"length\", len, true).\n    A.length = len;\n    // 20. Return A.\n    return A;\n  };\n};\n\n// https://tc39.github.io/ecma262/#sec-array.prototype.find\nif (!Array.prototype.find) {\n  Object.defineProperty(Array.prototype, 'find', {\n    value: function(predicate) {\n     // 1. Let O be ? ToObject(this value).\n      if (this == null) {\n        throw new TypeError('\"this\" is null or not defined');\n      }\n\n      var o = Object(this);\n\n      // 2. Let len be ? ToLength(? Get(O, \"length\")).\n      var len = o.length >>> 0;\n\n      // 3. If IsCallable(predicate) is false, throw a TypeError exception.\n      if (typeof predicate !== 'function') {\n        throw new TypeError('predicate must be a function');\n      }\n\n      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.\n      var thisArg = arguments[1];\n\n      // 5. Let k be 0.\n      var k = 0;\n\n      // 6. Repeat, while k < len\n      while (k < len) {\n        // a. Let Pk be ! ToString(k).\n        // b. Let kValue be ? Get(O, Pk).\n        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).\n        // d. If testResult is true, return kValue.\n        var kValue = o[k];\n        if (predicate.call(thisArg, kValue, k, o)) {\n          return kValue;\n        }\n        // e. Increase k by 1.\n        k++;\n      }\n\n      // 7. Return undefined.\n      return undefined;\n    },\n    configurable: true,\n    writable: true\n  });\n}\n\n\n})\n.call('object' === typeof self && self || 'object' === typeof global && global || {});\n";

	var jsonPolyfill = "//  json2.js\n//  2017-06-12\n//  Public Domain.\n//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.\n\n//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO\n//  NOT CONTROL.\n\n//  This file creates a global JSON object containing two methods: stringify\n//  and parse. This file provides the ES5 JSON capability to ES3 systems.\n//  If a project might run on IE8 or earlier, then this file should be included.\n//  This file does nothing on ES5 systems.\n\n//      JSON.stringify(value, replacer, space)\n//          value       any JavaScript value, usually an object or array.\n//          replacer    an optional parameter that determines how object\n//                      values are stringified for objects. It can be a\n//                      function or an array of strings.\n//          space       an optional parameter that specifies the indentation\n//                      of nested structures. If it is omitted, the text will\n//                      be packed without extra whitespace. If it is a number,\n//                      it will specify the number of spaces to indent at each\n//                      level. If it is a string (such as \"\\t\" or \"&nbsp;\"),\n//                      it contains the characters used to indent at each level.\n//          This method produces a JSON text from a JavaScript value.\n//          When an object value is found, if the object contains a toJSON\n//          method, its toJSON method will be called and the result will be\n//          stringified. A toJSON method does not serialize: it returns the\n//          value represented by the name/value pair that should be serialized,\n//          or undefined if nothing should be serialized. The toJSON method\n//          will be passed the key associated with the value, and this will be\n//          bound to the value.\n\n//          For example, this would serialize Dates as ISO strings.\n\n//              Date.prototype.toJSON = function (key) {\n//                  function f(n) {\n//                      // Format integers to have at least two digits.\n//                      return (n < 10)\n//                          ? \"0\" + n\n//                          : n;\n//                  }\n//                  return this.getUTCFullYear()   + \"-\" +\n//                       f(this.getUTCMonth() + 1) + \"-\" +\n//                       f(this.getUTCDate())      + \"T\" +\n//                       f(this.getUTCHours())     + \":\" +\n//                       f(this.getUTCMinutes())   + \":\" +\n//                       f(this.getUTCSeconds())   + \"Z\";\n//              };\n\n//          You can provide an optional replacer method. It will be passed the\n//          key and value of each member, with this bound to the containing\n//          object. The value that is returned from your method will be\n//          serialized. If your method returns undefined, then the member will\n//          be excluded from the serialization.\n\n//          If the replacer parameter is an array of strings, then it will be\n//          used to select the members to be serialized. It filters the results\n//          such that only members with keys listed in the replacer array are\n//          stringified.\n\n//          Values that do not have JSON representations, such as undefined or\n//          functions, will not be serialized. Such values in objects will be\n//          dropped; in arrays they will be replaced with null. You can use\n//          a replacer function to replace those with JSON values.\n\n//          JSON.stringify(undefined) returns undefined.\n\n//          The optional space parameter produces a stringification of the\n//          value that is filled with line breaks and indentation to make it\n//          easier to read.\n\n//          If the space parameter is a non-empty string, then that string will\n//          be used for indentation. If the space parameter is a number, then\n//          the indentation will be that many spaces.\n\n//          Example:\n\n//          text = JSON.stringify([\"e\", {pluribus: \"unum\"}]);\n//          // text is '[\"e\",{\"pluribus\":\"unum\"}]'\n\n//          text = JSON.stringify([\"e\", {pluribus: \"unum\"}], null, \"\\t\");\n//          // text is '[\\n\\t\"e\",\\n\\t{\\n\\t\\t\"pluribus\": \"unum\"\\n\\t}\\n]'\n\n//          text = JSON.stringify([new Date()], function (key, value) {\n//              return this[key] instanceof Date\n//                  ? \"Date(\" + this[key] + \")\"\n//                  : value;\n//          });\n//          // text is '[\"Date(---current time---)\"]'\n\n//      JSON.parse(text, reviver)\n//          This method parses a JSON text to produce an object or array.\n//          It can throw a SyntaxError exception.\n\n//          The optional reviver parameter is a function that can filter and\n//          transform the results. It receives each of the keys and values,\n//          and its return value is used instead of the original value.\n//          If it returns what it received, then the structure is not modified.\n//          If it returns undefined then the member is deleted.\n\n//          Example:\n\n//          // Parse the text. Values that look like ISO date strings will\n//          // be converted to Date objects.\n\n//          myData = JSON.parse(text, function (key, value) {\n//              var a;\n//              if (typeof value === \"string\") {\n//                  a =\n//   /^(\\d{4})-(\\d{2})-(\\d{2})T(\\d{2}):(\\d{2}):(\\d{2}(?:\\.\\d*)?)Z$/.exec(value);\n//                  if (a) {\n//                      return new Date(Date.UTC(\n//                         +a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]\n//                      ));\n//                  }\n//                  return value;\n//              }\n//          });\n\n//          myData = JSON.parse(\n//              \"[\\\"Date(09/09/2001)\\\"]\",\n//              function (key, value) {\n//                  var d;\n//                  if (\n//                      typeof value === \"string\"\n//                      && value.slice(0, 5) === \"Date(\"\n//                      && value.slice(-1) === \")\"\n//                  ) {\n//                      d = new Date(value.slice(5, -1));\n//                      if (d) {\n//                          return d;\n//                      }\n//                  }\n//                  return value;\n//              }\n//          );\n\n//  This is a reference implementation. You are free to copy, modify, or\n//  redistribute.\n\n/*jslint\n    eval, for, this\n*/\n\n/*property\n    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,\n    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,\n    lastIndex, length, parse, prototype, push, replace, slice, stringify,\n    test, toJSON, toString, valueOf\n*/\n\n\n// Create a JSON object only if one does not already exist. We create the\n// methods in a closure to avoid creating global variables.\n\nif (typeof JSON !== \"object\") {\n    JSON = {};\n}\n\n(function () {\n    \"use strict\";\n\n    var rx_one = /^[\\],:{}\\s]*$/;\n    var rx_two = /\\\\(?:[\"\\\\\\/bfnrt]|u[0-9a-fA-F]{4})/g;\n    var rx_three = /\"[^\"\\\\\\n\\r]*\"|true|false|null|-?\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d+)?/g;\n    var rx_four = /(?:^|:|,)(?:\\s*\\[)+/g;\n    var rx_escapable = /[\\\\\"\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/g;\n    var rx_dangerous = /[\\u0000\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/g;\n\n    function f(n) {\n        // Format integers to have at least two digits.\n        return (n < 10)\n            ? \"0\" + n\n            : n;\n    }\n\n    function this_value() {\n        return this.valueOf();\n    }\n\n    if (typeof Date.prototype.toJSON !== \"function\") {\n\n        Date.prototype.toJSON = function () {\n\n            return isFinite(this.valueOf())\n                ? (\n                    this.getUTCFullYear()\n                    + \"-\"\n                    + f(this.getUTCMonth() + 1)\n                    + \"-\"\n                    + f(this.getUTCDate())\n                    + \"T\"\n                    + f(this.getUTCHours())\n                    + \":\"\n                    + f(this.getUTCMinutes())\n                    + \":\"\n                    + f(this.getUTCSeconds())\n                    + \"Z\"\n                )\n                : null;\n        };\n\n        Boolean.prototype.toJSON = this_value;\n        Number.prototype.toJSON = this_value;\n        String.prototype.toJSON = this_value;\n    }\n\n    var gap;\n    var indent;\n    var meta;\n    var rep;\n\n\n    function quote(string) {\n\n// If the string contains no control characters, no quote characters, and no\n// backslash characters, then we can safely slap some quotes around it.\n// Otherwise we must also replace the offending characters with safe escape\n// sequences.\n\n        rx_escapable.lastIndex = 0;\n        return rx_escapable.test(string)\n            ? \"\\\"\" + string.replace(rx_escapable, function (a) {\n                var c = meta[a];\n                return typeof c === \"string\"\n                    ? c\n                    : \"\\\\u\" + (\"0000\" + a.charCodeAt(0).toString(16)).slice(-4);\n            }) + \"\\\"\"\n            : \"\\\"\" + string + \"\\\"\";\n    }\n\n\n    function str(key, holder) {\n\n// Produce a string from holder[key].\n\n        var i;          // The loop counter.\n        var k;          // The member key.\n        var v;          // The member value.\n        var length;\n        var mind = gap;\n        var partial;\n        var value = holder[key];\n\n// If the value has a toJSON method, call it to obtain a replacement value.\n\n        if (\n            value\n            && typeof value === \"object\"\n            && typeof value.toJSON === \"function\"\n        ) {\n            value = value.toJSON(key);\n        }\n\n// If we were called with a replacer function, then call the replacer to\n// obtain a replacement value.\n\n        if (typeof rep === \"function\") {\n            value = rep.call(holder, key, value);\n        }\n\n// What happens next depends on the value's type.\n\n        switch (typeof value) {\n        case \"string\":\n            return quote(value);\n\n        case \"number\":\n\n// JSON numbers must be finite. Encode non-finite numbers as null.\n\n            return (isFinite(value))\n                ? String(value)\n                : \"null\";\n\n        case \"boolean\":\n        case \"null\":\n\n// If the value is a boolean or null, convert it to a string. Note:\n// typeof null does not produce \"null\". The case is included here in\n// the remote chance that this gets fixed someday.\n\n            return String(value);\n\n// If the type is \"object\", we might be dealing with an object or an array or\n// null.\n\n        case \"object\":\n\n// Due to a specification blunder in ECMAScript, typeof null is \"object\",\n// so watch out for that case.\n\n            if (!value) {\n                return \"null\";\n            }\n\n// Make an array to hold the partial results of stringifying this object value.\n\n            gap += indent;\n            partial = [];\n\n// Is the value an array?\n\n            if (Object.prototype.toString.apply(value) === \"[object Array]\") {\n\n// The value is an array. Stringify every element. Use null as a placeholder\n// for non-JSON values.\n\n                length = value.length;\n                for (i = 0; i < length; i += 1) {\n                    partial[i] = str(i, value) || \"null\";\n                }\n\n// Join all of the elements together, separated with commas, and wrap them in\n// brackets.\n\n                v = partial.length === 0\n                    ? \"[]\"\n                    : gap\n                        ? (\n                            \"[\\n\"\n                            + gap\n                            + partial.join(\",\\n\" + gap)\n                            + \"\\n\"\n                            + mind\n                            + \"]\"\n                        )\n                        : \"[\" + partial.join(\",\") + \"]\";\n                gap = mind;\n                return v;\n            }\n\n// If the replacer is an array, use it to select the members to be stringified.\n\n            if (rep && typeof rep === \"object\") {\n                length = rep.length;\n                for (i = 0; i < length; i += 1) {\n                    if (typeof rep[i] === \"string\") {\n                        k = rep[i];\n                        v = str(k, value);\n                        if (v) {\n                            partial.push(quote(k) + (\n                                (gap)\n                                    ? \": \"\n                                    : \":\"\n                            ) + v);\n                        }\n                    }\n                }\n            } else {\n\n// Otherwise, iterate through all of the keys in the object.\n\n                for (k in value) {\n                    if (Object.prototype.hasOwnProperty.call(value, k)) {\n                        v = str(k, value);\n                        if (v) {\n                            partial.push(quote(k) + (\n                                (gap)\n                                    ? \": \"\n                                    : \":\"\n                            ) + v);\n                        }\n                    }\n                }\n            }\n\n// Join all of the member texts together, separated with commas,\n// and wrap them in braces.\n\n            v = partial.length === 0\n                ? \"{}\"\n                : gap\n                    ? \"{\\n\" + gap + partial.join(\",\\n\" + gap) + \"\\n\" + mind + \"}\"\n                    : \"{\" + partial.join(\",\") + \"}\";\n            gap = mind;\n            return v;\n        }\n    }\n\n// If the JSON object does not yet have a stringify method, give it one.\n\n    if (typeof JSON.stringify !== \"function\") {\n        meta = {    // table of character substitutions\n            \"\\b\": \"\\\\b\",\n            \"\\t\": \"\\\\t\",\n            \"\\n\": \"\\\\n\",\n            \"\\f\": \"\\\\f\",\n            \"\\r\": \"\\\\r\",\n            \"\\\"\": \"\\\\\\\"\",\n            \"\\\\\": \"\\\\\\\\\"\n        };\n        JSON.stringify = function (value, replacer, space) {\n\n// The stringify method takes a value and an optional replacer, and an optional\n// space parameter, and returns a JSON text. The replacer can be a function\n// that can replace values, or an array of strings that will select the keys.\n// A default replacer method can be provided. Use of the space parameter can\n// produce text that is more easily readable.\n\n            var i;\n            gap = \"\";\n            indent = \"\";\n\n// If the space parameter is a number, make an indent string containing that\n// many spaces.\n\n            if (typeof space === \"number\") {\n                for (i = 0; i < space; i += 1) {\n                    indent += \" \";\n                }\n\n// If the space parameter is a string, it will be used as the indent string.\n\n            } else if (typeof space === \"string\") {\n                indent = space;\n            }\n\n// If there is a replacer, it must be a function or an array.\n// Otherwise, throw an error.\n\n            rep = replacer;\n            if (replacer && typeof replacer !== \"function\" && (\n                typeof replacer !== \"object\"\n                || typeof replacer.length !== \"number\"\n            )) {\n                throw new Error(\"JSON.stringify\");\n            }\n\n// Make a fake root object containing our value under the key of \"\".\n// Return the result of stringifying the value.\n\n            return str(\"\", {\"\": value});\n        };\n    }\n\n\n// If the JSON object does not yet have a parse method, give it one.\n\n    if (typeof JSON.parse !== \"function\") {\n        JSON.parse = function (text, reviver) {\n\n// The parse method takes a text and an optional reviver function, and returns\n// a JavaScript value if the text is a valid JSON text.\n\n            var j;\n\n            function walk(holder, key) {\n\n// The walk method is used to recursively walk the resulting structure so\n// that modifications can be made.\n\n                var k;\n                var v;\n                var value = holder[key];\n                if (value && typeof value === \"object\") {\n                    for (k in value) {\n                        if (Object.prototype.hasOwnProperty.call(value, k)) {\n                            v = walk(value, k);\n                            if (v !== undefined) {\n                                value[k] = v;\n                            } else {\n                                delete value[k];\n                            }\n                        }\n                    }\n                }\n                return reviver.call(holder, key, value);\n            }\n\n\n// Parsing happens in four stages. In the first stage, we replace certain\n// Unicode characters with escape sequences. JavaScript handles many characters\n// incorrectly, either silently deleting them, or treating them as line endings.\n\n            text = String(text);\n            rx_dangerous.lastIndex = 0;\n            if (rx_dangerous.test(text)) {\n                text = text.replace(rx_dangerous, function (a) {\n                    return (\n                        \"\\\\u\"\n                        + (\"0000\" + a.charCodeAt(0).toString(16)).slice(-4)\n                    );\n                });\n            }\n\n// In the second stage, we run the text against regular expressions that look\n// for non-JSON patterns. We are especially concerned with \"()\" and \"new\"\n// because they can cause invocation, and \"=\" because it can cause mutation.\n// But just to be safe, we want to reject all unexpected forms.\n\n// We split the second stage into 4 regexp operations in order to work around\n// crippling inefficiencies in IE's and Safari's regexp engines. First we\n// replace the JSON backslash pairs with \"@\" (a non-JSON character). Second, we\n// replace all simple value tokens with \"]\" characters. Third, we delete all\n// open brackets that follow a colon or comma or that begin the text. Finally,\n// we look to see that the remaining characters are only whitespace or \"]\" or\n// \",\" or \":\" or \"{\" or \"}\". If that is so, then the text is safe for eval.\n\n            if (\n                rx_one.test(\n                    text\n                        .replace(rx_two, \"@\")\n                        .replace(rx_three, \"]\")\n                        .replace(rx_four, \"\")\n                )\n            ) {\n\n// In the third stage we use the eval function to compile the text into a\n// JavaScript structure. The \"{\" operator is subject to a syntactic ambiguity\n// in JavaScript: it can begin a block or an object literal. We wrap the text\n// in parens to eliminate the ambiguity.\n\n                j = eval(\"(\" + text + \")\");\n\n// In the optional fourth stage, we recursively walk the new structure, passing\n// each name/value pair to a reviver function for possible transformation.\n\n                return (typeof reviver === \"function\")\n                    ? walk({\"\": j}, \"\")\n                    : j;\n            }\n\n// If the text is not JSON parseable, then a SyntaxError is thrown.\n\n            throw new SyntaxError(\"JSON.parse\");\n        };\n    }\n}());\n";

	var objectKeysPolyfill = "// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys\nif (!Object.keys) {\n  Object.keys = (function() {\n    'use strict';\n    var hasOwnProperty = Object.prototype.hasOwnProperty,\n        hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),\n        dontEnums = [\n          'toString',\n          'toLocaleString',\n          'valueOf',\n          'hasOwnProperty',\n          'isPrototypeOf',\n          'propertyIsEnumerable',\n          'constructor'\n        ],\n        dontEnumsLength = dontEnums.length;\n\n    return function(obj) {\n      if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {\n        throw new TypeError('Object.keys called on non-object');\n      }\n\n      var result = [], prop, i;\n\n      for (prop in obj) {\n        if (hasOwnProperty.call(obj, prop)) {\n          result.push(prop);\n        }\n      }\n\n      if (hasDontEnumBug) {\n        for (i = 0; i < dontEnumsLength; i++) {\n          if (hasOwnProperty.call(obj, dontEnums[i])) {\n            result.push(dontEnums[i]);\n          }\n        }\n      }\n      return result;\n    };\n  }());\n}\n";

	var placeFile = "/*\nopts:\n- filePath\n- scale\n*/\nplaceFile = function(opts) {\n  opts = opts || {};\n\n  var doc = app.activeDocument;\n  var activeArtboardIndex = doc.artboards.getActiveArtboardIndex();\n  var artboardname = doc.artboards[activeArtboardIndex].name;\n  var svgFile = File(opts.filePath);\n  var newGroup = doc.groupItems.createFromFile(svgFile);\n  newGroup.name = opts.filePath;\n\n  if (artboardname !== '') {\n    var artboard = doc.artboards.getByName(artboardname);\n    var dimensions = {\n      x: artboard.artboardRect[0] + opts.position.x,\n      y: artboard.artboardRect[1] + (opts.position.y * -1),\n      width: artboard.artboardRect[2],\n      height: artboard.artboardRect[3]\n    };\n    newGroup.position = [ dimensions.x , dimensions.y ];\n  }\n\n  // https://illustrator-scripting-guide.readthedocs.io/jsobjref/SymbolItem/#symbolitem-resize\n  newGroup.resize(opts.scale * 100, opts.scale * 100, true, true, true, true, 100, Transformation.TOPLEFT);\n  newGroup.position = [\n    opts.position.x,\n    opts.position.y * -1\n  ];\n\n  return newGroup.name;\n}\n";

	var convertColor = "\nvar swatches = {\n  \"White\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":0},\n  \"Black 100\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":100},\n  \"Gray 80\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":80},\n  \"Gray 55\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":55},\n  \"Gray 25\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":25},\n  \"Gray 15\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":15},\n  \"Gray 12\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":12},\n  \"Gray 6\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":6},\n  \"Blue 1\": { \"cyan\":96, \"magenta\":18, \"yellow\":0, \"black\":26},\n  \"Blue 2\": { \"cyan\":96, \"magenta\":18, \"yellow\":0, \"black\":0},\n  \"Blue 3\": { \"cyan\":38, \"magenta\":7, \"yellow\":0, \"black\":0},\n  \"Blue 4\": { \"cyan\":19, \"magenta\":4, \"yellow\":0, \"black\":0},\n  \"Blue 5\": { \"cyan\":8, \"magenta\":2, \"yellow\":0, \"black\":0},\n  \"Red 1\": { \"cyan\":0, \"magenta\":92, \"yellow\":75, \"black\":15},\n  \"Red 2\": { \"cyan\":0, \"magenta\":92, \"yellow\":75, \"black\":0},\n  \"Red 4\": { \"cyan\":0, \"magenta\":18, \"yellow\":15, \"black\":0},\n  \"Green 1\": { \"cyan\":64, \"magenta\":0, \"yellow\":92, \"black\":18},\n  \"Green 2\": { \"cyan\":64, \"magenta\":0, \"yellow\":92, \"black\":0},\n  \"Green 3\": { \"cyan\":38, \"magenta\":0, \"yellow\":55, \"black\":0},\n  \"Green 4\": { \"cyan\":23, \"magenta\":0, \"yellow\":33, \"black\":0},\n  \"Green 5\": { \"cyan\":9, \"magenta\":0, \"yellow\":13, \"black\":0},\n  \"Orange 1\": { \"cyan\":0, \"magenta\":42, \"yellow\":96, \"black\":10},\n  \"Orange 2\": { \"cyan\":0, \"magenta\":42, \"yellow\":96, \"black\":0},\n  \"Orange 3\": { \"cyan\":0, \"magenta\":25, \"yellow\":58, \"black\":0},\n  \"Wine 1\": { \"cyan\":0, \"magenta\":90, \"yellow\":0, \"black\":25},\n  \"Wine 2\": { \"cyan\":0, \"magenta\":45, \"yellow\":0, \"black\":12},\n  \"Yellow 1\": { \"cyan\":0, \"magenta\":14, \"yellow\":86, \"black\":8},\n  \"Yellow 2\": { \"cyan\":0, \"magenta\":14, \"yellow\":86, \"black\":0},\n  \"Champagne 1\": { \"cyan\":6, \"magenta\":8, \"yellow\":28, \"black\":0},\n  \"Champagne 2\": { \"cyan\":3, \"magenta\":4, \"yellow\":14, \"black\":0},\n  \"Mansion 1\": { \"cyan\":0, \"magenta\":0, \"yellow\":42, \"black\":30},\n  \"Mansion 2\": { \"cyan\":0, \"magenta\":0, \"yellow\":21, \"black\":15},\n  \"Mansion 3\": { \"cyan\":0, \"magenta\":0, \"yellow\":9, \"black\":6},\n  \"ELX-Red 1\": { \"cyan\":0, \"magenta\":92, \"yellow\":75, \"black\":30},\n  \"ELX-Red 2\": { \"cyan\":0, \"magenta\":92, \"yellow\":75, \"black\":15},\n  \"ELX-Red 3\": { \"cyan\":0, \"magenta\":92, \"yellow\":75, \"black\":0},\n  \"ELX-Red 4\": { \"cyan\":0, \"magenta\":60, \"yellow\":49, \"black\":0},\n  \"ELX-Red 5\": { \"cyan\":0, \"magenta\":40, \"yellow\":33, \"black\":0},\n  \"ELX-Red 6\": { \"cyan\":0, \"magenta\":18, \"yellow\":5, \"black\":0},\n  \"ELX-Blue 1\": { \"cyan\":96, \"magenta\":18, \"yellow\":0, \"black\":48},\n  \"ELX-Blue 2\": { \"cyan\":96, \"magenta\":18, \"yellow\":0, \"black\":24},\n  \"ELX-Blue 3\": { \"cyan\":96, \"magenta\":18, \"yellow\":0, \"black\":0},\n  \"ELX-Blue 4\": { \"cyan\":50, \"magenta\":11, \"yellow\":0, \"black\":0},\n  \"ELX-Blue 5\": { \"cyan\":27, \"magenta\":6, \"yellow\":0, \"black\":0},\n  \"ELX-Blue 6\": { \"cyan\":13, \"magenta\":4, \"yellow\":0, \"black\":0},\n  \"ELX-Gray 1\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":55},\n  \"ELX-Gray 2\": { \"cyan\":0, \"magenta\":0, \"yellow\":0, \"black\":15},\n  \"ELX-Green 1\": { \"cyan\":64, \"magenta\":0, \"yellow\":92, \"black\":18},\n  \"ELX-Green 2\": { \"cyan\":64, \"magenta\":0, \"yellow\":92, \"black\":0},\n  \"ELX-Green 3\": { \"cyan\":38, \"magenta\":0, \"yellow\":55, \"black\":0},\n  \"ELX-Green 4\": { \"cyan\":23, \"magenta\":0, \"yellow\":33, \"black\":0},\n  \"ELX-Green 5\": { \"cyan\":9, \"magenta\":0, \"yellow\":13, \"black\":0},\n  \"ELX-Purple 1\": { \"cyan\":73, \"magenta\":92, \"yellow\":7, \"black\":0},\n  \"ELX-Purple 2\": { \"cyan\":45, \"magenta\":60, \"yellow\":3, \"black\":0},\n  \"ELX-Purple 3\": { \"cyan\":33, \"magenta\":46, \"yellow\":2, \"black\":0},\n  \"ELX-Purple 4\": { \"cyan\":22, \"magenta\":32, \"yellow\":2, \"black\":0},\n  \"ELX-Purple 5\": { \"cyan\":11, \"magenta\":14, \"yellow\":0, \"black\":0},\n  \"ELX-Teal 1\": { \"cyan\":85, \"magenta\":34, \"yellow\":48, \"black\":85},\n  \"ELX-Teal 2\": { \"cyan\":74, \"magenta\":13, \"yellow\":35, \"black\":0},\n  \"ELX-Teal 3\": { \"cyan\":60, \"magenta\":0, \"yellow\":28, \"black\":0},\n  \"ELX-Teal 4\": { \"cyan\":41, \"magenta\":0, \"yellow\":16, \"black\":0},\n  \"ELX-Teal 5\": { \"cyan\":21, \"magenta\":0, \"yellow\":7, \"black\":0},\n  \"ELX-CoolGray 1\": { \"cyan\":75, \"magenta\":65, \"yellow\":45, \"black\":105},\n  \"ELX-CoolGray 2\": { \"cyan\":58, \"magenta\":48, \"yellow\":30, \"black\":1},\n  \"ELX-CoolGray 3\": { \"cyan\":45, \"magenta\":35, \"yellow\":22, \"black\":2},\n  \"ELX-CoolGray 4\": { \"cyan\":31, \"magenta\":24, \"yellow\":12, \"black\":3},\n  \"ELX-CoolGray 5\": { \"cyan\":18, \"magenta\":12, \"yellow\":7, \"black\":4},\n  \"ELX-Gold 1\": { \"cyan\":53, \"magenta\":53, \"yellow\":100, \"black\":0},\n  \"ELX-Gold 2\": { \"cyan\":36, \"magenta\":37, \"yellow\":96, \"black\":0},\n  \"ELX-Gold 3\": { \"cyan\":25, \"magenta\":28, \"yellow\":95, \"black\":0},\n  \"ELX-Gold 4\": { \"cyan\":14, \"magenta\":19, \"yellow\":74, \"black\":0},\n  \"ELX-Gold 5\": { \"cyan\":4, \"magenta\":6, \"yellow\":40, \"black\":0}\n};\n\n/*\nDefine as strings so that text editors\ncan display the colors inline\n*/\nvar colorList = [\n\n  // colors for 'North America Newspaper' color settings in Illustrator\n  {\"rgb\":\"rgb(41, 117, 163)\",\"swatch\":\"Blue 1\"},\n  {\"rgb\":\"rgb(42, 144, 201)\",\"swatch\":\"Blue 2\"},\n  {\"rgb\":\"rgb(148, 196, 227)\",\"swatch\":\"Blue 3\"},\n  {\"rgb\":\"rgb(210, 71, 78)\",\"swatch\":\"Red 1\"},\n  {\"rgb\":\"rgb(195, 54, 58)\",\"swatch\":\"Red 2\"},\n  {\"rgb\":\"rgb(222, 131, 118)\",\"swatch\":\"Red 3\"},\n  {\"rgb\":\"rgb(231, 166, 153)\",\"swatch\":\"Red 4\"},\n  {\"rgb\":\"rgb(84, 153, 86)\",\"swatch\":\"Green 1\"},\n  {\"rgb\":\"rgb(218, 147, 63)\",\"swatch\":\"Orange 1\"},\n  {\"rgb\":\"rgb(229, 158, 63)\",\"swatch\":\"Orange 2\"},\n  {\"rgb\":\"rgb(245, 210, 75)\",\"swatch\":\"Yellow 2\"},\n  {\"rgb\":\"rgb(175, 47, 113)\",\"swatch\":\"Purple 1\"},\n\n  {\"rgb\":\"rgb(129, 167, 204)\",\"swatch\":\"Black\"},\n  {\"rgb\":\"rgb(0,0,0)\",\"swatch\":\"Black 100\"},\n  {\"rgb\":\"rgb(35, 31, 32)\",\"swatch\":\"Black 100\"},\n  {\"rgb\":\"rgb(50,50,50)\",\"swatch\":\"Black 100\"},\n  {\"rgb\":\"rgb(0,121,174)\",\"swatch\":\"Blue 1\"},\n  {\"rgb\":\"rgb(11, 120, 171)\",\"swatch\":\"Blue 1\"},\n  {\"rgb\":\"rgb(0,152,219)\",\"swatch\":\"Blue 2\"},\n  {\"rgb\":\"rgb(26, 151, 212)\",\"swatch\":\"Blue 2\"},\n  {\"rgb\":\"rgb(52, 143, 195)\",\"swatch\":\"Blue 2\"},\n  {\"rgb\":\"rgb(148, 188, 215)\",\"swatch\":\"Blue 3\"},\n  {\"rgb\":\"rgb(149,203,238)\",\"swatch\":\"Blue 3\"},\n  {\"rgb\":\"rgb(197, 216, 229)\",\"swatch\":\"Blue 4\"},\n  {\"rgb\":\"rgb(201,226,245)\",\"swatch\":\"Blue 4\"},\n  {\"rgb\":\"rgb(228, 233, 237)\",\"swatch\":\"Blue 5\"},\n  {\"rgb\":\"rgb(230,239,249)\",\"swatch\":\"Blue 5\"},\n  {\"rgb\":\"rgb(238,226,189)\",\"swatch\":\"Champagne 1\"},\n  {\"rgb\":\"rgb(245,238,218)\",\"swatch\":\"Champagne 2\"},\n  {\"rgb\":\"rgb(188, 163, 53)\",\"swatch\":\"Gold 1\"},\n  {\"rgb\":\"rgb(227, 190, 58)\",\"swatch\":\"Gold 2\"},\n  {\"rgb\":\"rgb(235, 201, 71)\",\"swatch\":\"Gold 3\"},\n  {\"rgb\":\"rgb(225,226,227)\",\"swatch\":\"Gray 12\"},\n  {\"rgb\":\"rgb(217,217,217)\",\"swatch\":\"Gray 15\"},\n  {\"rgb\":\"rgb(190,190,190)\",\"swatch\":\"Gray 25\"},\n  {\"rgb\":\"rgb(203, 204, 203)\",\"swatch\":\"Gray 25\"},\n  {\"rgb\":\"rgb(240,240,240)\",\"swatch\":\"Gray 6\"},\n  {\"rgb\":\"rgb(102, 102, 103)\",\"swatch\":\"Gray 80\"},\n  {\"rgb\":\"rgb(113,113,113)\",\"swatch\":\"Gray 80\"},\n  {\"rgb\":\"rgb(88, 88, 91)\",\"swatch\":\"Gray 80\"},\n  {\"rgb\":\"rgb(82,160,69)\",\"swatch\":\"Green 1\"},\n  {\"rgb\":\"rgb(109, 180, 93)\",\"swatch\":\"Green 2\"},\n  {\"rgb\":\"rgb(99,188,81)\",\"swatch\":\"Green 2\"},\n  {\"rgb\":\"rgb(158, 199, 145)\",\"swatch\":\"Green 3\"},\n  {\"rgb\":\"rgb(162,210,146)\",\"swatch\":\"Green 3\"},\n  {\"rgb\":\"rgb(198,226,186)\",\"swatch\":\"Green 4\"},\n  {\"rgb\":\"rgb(230,242,225)\",\"swatch\":\"Green 5\"},\n  {\"rgb\":\"rgb(191,185,128)\",\"swatch\":\"Mansion 1\"},\n  {\"rgb\":\"rgb(222,218,185)\",\"swatch\":\"Mansion 2\"},\n  {\"rgb\":\"rgb(220, 148, 47)\",\"swatch\":\"Orange 1\"},\n  {\"rgb\":\"rgb(226,147,32)\",\"swatch\":\"Orange 1\"},\n  {\"rgb\":\"rgb(228, 162, 77)\",\"swatch\":\"Orange 2\"},\n  {\"rgb\":\"rgb(249,162,36)\",\"swatch\":\"Orange 2\"},\n  {\"rgb\":\"rgb(230, 186, 128)\",\"swatch\":\"Orange 3\"},\n  {\"rgb\":\"rgb(253,196,124)\",\"swatch\":\"Orange 3\"},\n  {\"rgb\":\"rgb(182, 25, 43)\",\"swatch\":\"Red 1\"},\n  {\"rgb\":\"rgb(206,49,57)\",\"swatch\":\"Red 1\"},\n  {\"rgb\":\"rgb(219, 60, 66)\",\"swatch\":\"Red 2\"},\n  {\"rgb\":\"rgb(238,58,67)\",\"swatch\":\"Red 2\"},\n  {\"rgb\":\"rgb(244, 132, 116)\",\"swatch\": \"Red 3\"},\n  {\"rgb\":\"rgb(248, 170, 153)\",\"swatch\": \"Red 4\"},\n  {\"rgb\":\"rgb(252,214,202)\",\"swatch\": \"Red 5\"},\n  {\"rgb\":\"rgb(255,255,255)\",\"swatch\":\"White\"},\n  {\"rgb\":\"rgb(187,43,119)\",\"swatch\":\"Wine 1\"},\n  {\"rgb\":\"rgb(217,145,178)\",\"swatch\":\"Wine 2\"},\n  {\"rgb\":\"rgb(237,198,57)\",\"swatch\":\"Yellow 1\"},\n  {\"rgb\":\"rgb(255,214,61)\",\"swatch\":\"Yellow 2\"},\n  {\"swatch\":\"ELX-Red 1\",\"rgb\":\"rgb(177,40,46)\"},\n  {\"swatch\":\"ELX-Red 2\",\"rgb\":\"rgb(206,49,57)\"},\n  {\"swatch\":\"ELX-Red 3\",\"rgb\":\"rgb(238,58,67)\"},\n  {\"swatch\":\"ELX-Red 4\",\"rgb\":\"rgb(244,132,116)\"},\n  {\"swatch\":\"ELX-Red 5\",\"rgb\":\"rgb(248,170,154)\"},\n  {\"swatch\":\"ELX-Red 6\",\"rgb\":\"rgb(252,214,203)\"},\n  {\"swatch\":\"ELX-Blue 1\",\"rgb\":\"rgb(0,93,136)\"},\n  {\"swatch\":\"ELX-Blue 2\",\"rgb\":\"rgb(0,123,177)\"},\n  {\"swatch\":\"ELX-Blue 3\",\"rgb\":\"rgb(0,152,219)\"},\n  {\"swatch\":\"ELX-Blue 4\",\"rgb\":\"rgb(118,189,232)\"},\n  {\"swatch\":\"ELX-Blue 5\",\"rgb\":\"rgb(181,215,241)\"},\n  {\"swatch\":\"ELX-Blue 6\",\"rgb\":\"rgb(216,231,246)\"},\n  {\"swatch\":\"ELX-Gray 1\",\"rgb\":\"rgb(137,139,142)\"},\n  {\"swatch\":\"ELX-Gray 2\",\"rgb\":\"rgb(219,220,222)\"},\n  {\"swatch\":\"ELX-Green 1\",\"rgb\":\"rgb(82,160,69)\"},\n  {\"swatch\":\"ELX-Green 2\",\"rgb\":\"rgb(99,188,81)\"},\n  {\"swatch\":\"ELX-Green 3\",\"rgb\":\"rgb(163,210,147)\"},\n  {\"swatch\":\"ELX-Green 4\",\"rgb\":\"rgb(198,226,187)\"},\n  {\"swatch\":\"ELX-Green 5\",\"rgb\":\"rgb(230,242,225)\"},\n  {\"swatch\":\"ELX-Purple 1\",\"rgb\":\"rgb(104,60,142)\"},\n  {\"swatch\":\"ELX-Purple 2\",\"rgb\":\"rgb(149,116,174)\"},\n  {\"swatch\":\"ELX-Purple 3\",\"rgb\":\"rgb(172,142,190)\"},\n  {\"swatch\":\"ELX-Purple 4\",\"rgb\":\"rgb(195,173,206)\"},\n  {\"swatch\":\"ELX-Purple 5\",\"rgb\":\"rgb(221,214,234)\"},\n  {\"swatch\":\"ELX-Teal 1\",\"rgb\":\"rgb(24,125,128)\"},\n  {\"swatch\":\"ELX-Teal 2\",\"rgb\":\"rgb(47,167,170)\"},\n  {\"swatch\":\"ELX-Teal 3\",\"rgb\":\"rgb(90,196,194)\"},\n  {\"swatch\":\"ELX-Teal 4\",\"rgb\":\"rgb(144,212,216)\"},\n  {\"swatch\":\"ELX-Teal 5\",\"rgb\":\"rgb(197,231,235)\"},\n  {\"swatch\":\"ELX-CoolGray 1\",\"rgb\":\"rgb(84,92,111)\"},\n  {\"swatch\":\"ELX-CoolGray 2\",\"rgb\":\"rgb(123,128,151)\"},\n  {\"swatch\":\"ELX-CoolGray 3\",\"rgb\":\"rgb(147,153,173)\"},\n  {\"swatch\":\"ELX-CoolGray 4\",\"rgb\":\"rgb(176,180,199)\"},\n  {\"swatch\":\"ELX-CoolGray 5\",\"rgb\":\"rgb(205,211,221)\"},\n  {\"swatch\":\"ELX-Gold 1\",\"rgb\":\"rgb(142,121,58)\"},\n  {\"swatch\":\"ELX-Gold 2\",\"rgb\":\"rgb(175,151,58)\"},\n  {\"swatch\":\"ELX-Gold 3\",\"rgb\":\"rgb(199,172,55)\"},\n  {\"swatch\":\"ELX-Gold 4\",\"rgb\":\"rgb(222,195,97)\"},\n  {\"swatch\":\"ELX-Gold 5\",\"rgb\":\"rgb(245,230,168)\"}\n];\n/*\nConvert into machine-readable integers\n*/\nfunction parseCMYKString(str) {\n  if (!str || !str.split) {\n    throw('str invalid: '+str)\n  }\n  var cmyk = str.split(/\\(|,|\\)/g).slice(1,5);\n  for (var i = 0; i < cmyk.length; i++) {\n    cmyk[i] = parseInt(cmyk[i], 10);\n  }\n  return cmyk;\n}\nfunction parseRGBString(str) {\n  if (!str || !str.split) {\n    throw('str invalid: '+str)\n  }\n  var rgb = str.split(/\\(|,|\\)/g).slice(1,4);\n  return rgb.map(function(channel) {\n    return parseInt(channel, 10);;\n  });\n}\n\nvar colorListIntegers = colorList.map(function(color) {\n  if (!color.rgb) {\n    throw('No rgb: '+color.rgb)\n  }\n  return {\n    rgb: parseRGBString(color.rgb),\n    swatch: color.swatch\n  };\n});\n\nfunction RGBtoCYMKfromDict(rgb) {\n  var match = colorListIntegers.find(function(color) {\n    var redMatch = Math.abs(rgb.red - color.rgb[0]) < 10;\n    var greenMatch = Math.abs(rgb.green - color.rgb[1]) < 10;\n    var blueMatch = Math.abs(rgb.blue - color.rgb[2]) < 10;\n    return (redMatch && greenMatch && blueMatch);\n  });\n  if (!match) {\n    throw new ColorException(rgb);\n  }\n\n  var swatch = swatches[match.swatch];\n  var newCMYKColor = new CMYKColor();\n  newCMYKColor.cyan = swatch.cyan;\n  newCMYKColor.magenta = swatch.magenta;\n  newCMYKColor.yellow = swatch.yellow;\n  newCMYKColor.black = swatch.black;\n\n  var spot;\n  try {\n    // attempt to find live swatch within document\n    spot = app.activeDocument.spots.getByName(match.swatch);\n  } catch (err) {\n    // throw('No spot color with name \"'+ match.swatch +'\"')\n  }\n  if (spot) {\n    newCMYKColor = new SpotColor();\n    newCMYKColor.spot = spot;\n  }\n  return newCMYKColor;\n}\n\nfunction ColorException(color) {\n   var string = 'rgb('+color.red+', '+color.green+', '+color.blue+')';\n   if (color.red === undefined) {\n     string = color;\n   }\n   this.color = color;\n   this.colorString = string;\n   this.name = 'ColorException';\n   this.message = 'Color invalid and/or missing from colorList: \"'+string+'\"';\n}\n\nfunction convertColor(color) {\n  if (color.typename === 'NoColor') {\n    // it's a blank color, ignore\n    return color;\n  }\n  if (color.typename === 'SpotColor') {\n    // it's a swatch color, ignore\n    return color;\n  }\n  if (color.typename === 'CMYKColor') {\n    // it's a false cmyk, convert to rgb\n    var colors = app.convertSampleColor(ImageColorSpace.CMYK, [color.cyan, color.magenta, color.yellow, color.black], ImageColorSpace.RGB, ColorConvertPurpose.defaultpurpose);\n    color = new RGBColor();\n    color.red = parseInt(colors[0], 10);\n    color.green = parseInt(colors[1], 10);\n    color.blue = parseInt(colors[2], 10);\n  }\n  if (color.typename === 'GrayColor') {\n    // it's a grayscale color\n    var newCMYKColor = new CMYKColor();\n    newCMYKColor.cyan = 0;\n    newCMYKColor.magenta = 0;\n    newCMYKColor.yellow = 0;\n    newCMYKColor.black = color.gray;\n    return color;\n  }\n  if (color.typename === 'RGBColor') {\n    return RGBtoCYMKfromDict(color);\n  }\n  throw new ColorException(color);\n}\n";

	var convertGroupColors = "convertGroupColors = function(groupName) {\n\n  var group = querySelector(groupName);\n  var items = getAllPageItems(group.pageItems);\n  var missingColors = [];\n  Array.prototype.forEach.call(items, function(item) {\n    if (item.locked || item.hidden) {\n      return;\n    }\n    var newFillColor = null;\n    var newStrokeColor = null;\n    var newTextColor = null;\n    try {\n      if ('fillColor' in item && item.filled && item.clipping === false) {\n        newFillColor = convertColor(item.fillColor);\n      }\n      if ('strokeColor' in item) {\n        newStrokeColor = convertColor(item.strokeColor);\n      }\n      if ('textRange' in item) {\n        newTextColor = convertColor(item.textRange.characterAttributes.fillColor);\n      }\n    } catch (err) {\n      missingColors.push(err.colorString);\n    }\n\n    if (newFillColor) {\n      item.fillColor = newFillColor;\n    }\n    if (newStrokeColor) {\n      item.strokeColor = newStrokeColor;\n    }\n    if (newTextColor) {\n      item.textRange.characterAttributes.fillColor = newTextColor;\n    }\n  }); // end forEach\n  missingColors = missingColors.filter(function(color) {\n    return !!color;\n  });\n  var missingColorsString = missingColors.filter(onlyUnique).join('\\n');\n  if (missingColors.length > 0) {\n    alert('Unable to convert the following colors to CMYK, as they are not defined in colorDict: \\n' + missingColorsString + '\\n');\n    throw('The following RGB colors are missing from colorDict: \\n' + missingColorsString + '\\n');\n  }\n}\n\nfunction onlyUnique(value, index, self) {\n  return self.indexOf(value) === index;\n}\n";

	var getSizeOfSelection = "\ngetSizeOfSelection = function() {\n  var docSelection = app.activeDocument.selection;\n  if (docSelection.length === 0) {\n    return false;\n  }\n  return convertBounds(docSelection[0].visibleBounds);\n}\n\nconvertBounds = function(bounds) {\n  return {\n    x: bounds[0],\n    y: bounds[1] * -1,\n    width: bounds[2] - bounds[0],\n    height: bounds[1] - bounds[3]\n  }\n};\n";

	var textPointsToArea = "/*\ntextPointsToFrame:\nAccepts a group containing one or more text-on-point textFrames\nAnd combined them into a more useful areaText\n\nopts:\n- query: Query string for selecting text item\n- useParentWidth: if true, get width from parent element\n*/\ntextPointsToArea = function(opts) {\n  opts = opts || {};\n  var groups = querySelectorAll(opts.query);\n  if (!groups || groups.length === 0) {\n    return null;\n  }\n\n  var results = groups.map(function(originalGroup) {\n\n    // get dimensions for new areaText\n    var bounds = convertBounds(originalGroup.visibleBounds);\n    if (opts.useParentWidth) {\n      bounds.width = convertBounds(originalGroup.parent.visibleBounds).width;\n    }\n    if (opts.width) {\n      bounds.width = opts.width;\n    }\n\n    // extract text from existing points\n    var lines = Array.prototype.map.call(originalGroup.textFrames, function(frame) {\n      return {\n      \ttext: frame.contents,\n      \ty: frame.anchor[1],\n      \tframe: frame\n      };\n    });\n    lines.sort(function(a, b) { return b.y - a.y });\n    var text = lines.map(function(t) { return t.text }).join(' ');\n\n    if (typeof originalGroup.textFrames === 'undefined') {\n      text = originalGroup.contents;\n    }\n\n    // create a new textframe to put everything in\n    var rectRef = originalGroup.parent.pathItems.rectangle(\n      bounds.y,\n      bounds.x,\n      bounds.width,\n      bounds.height\n    );\n    var areaTextRef = originalGroup.parent.textFrames.areaText(rectRef);\n    areaTextRef.contents = text;\n    areaTextRef.name = originalGroup.name;\n\n    copyCharacterStyles(originalGroup, areaTextRef);\n    copyParagraphStyles(originalGroup, areaTextRef);\n\n    // set y position as bounds.y is slightly off\n    areaTextRef.top = originalGroup.top;\n\n    // clean up\n    originalGroup.remove();\n\n\n    return {\n      text: text,\n      name: name\n    };\n\n  });\n\n  return results;\n\n}\n\nfunction copyCharacterStyles(oldElement, newElement) {\n  var originalCharAttrs;\n  if (!oldElement.textFrames) {\n    originalCharAttrs = oldElement.textRange.characterAttributes;\n  } else {\n    originalCharAttrs = oldElement.textFrames[0].textRange.characterAttributes;\n  }\n  Object.keys(originalCharAttrs).forEach(function(charAttrName) {\n    try {\n      if (\n        charAttrName in originalCharAttrs &&\n        !!originalCharAttrs[charAttrName] &&\n        charAttrName.indexOf('stroke') === -1\n      ) {\n        newElement.textRange.characterAttributes[charAttrName] = originalCharAttrs[charAttrName];\n      }\n    } catch (err) {\n      // throw('Error accessing property \"'+charAttrName+'\"')\n    }\n  });\n\n}\n\nfunction copyParagraphStyles(oldElement, newElement) {\n  var originalParAttrs;\n  if (!oldElement.textFrames) {\n    originalParAttrs = oldElement.textRange.paragraphAttributes;\n  } else {\n    originalParAttrs = oldElement.textFrames[0].textRange.paragraphAttributes;\n  }\n  Object.keys(originalParAttrs).forEach(function(parAttrName) {\n\n    // for some reason, accessing some paragraph styles causes an error\n    try {\n      if (\n        parAttrName in originalParAttrs &&\n        originalParAttrs[parAttrName] !== undefined\n      ) {\n        newElement.textRange.paragraphAttributes[parAttrName] = originalParAttrs[parAttrName];\n      }\n    } catch (e) {\n      // throw('Error accessing property \"'+parAttrName+'\"')\n    }\n  });\n\n}\n";

	var realignTextPoint = "/*\nAssuming it's left-aligned\n*/\n\nrealignTextPoint = function(opts) {\n  var textOnPoint = opts.item;\n  var width = convertBounds(textOnPoint.visibleBounds).width;\n  var newAlignment;\n  try {\n    newAlignment = Justification[opts.alignment.toUpperCase()];\n  } catch (e) {\n    throw(\"Not a vaid alignment: '\" + opts.alignment + \"'\")\n  }\n  var oldAlignment = textOnPoint.paragraphs[0].paragraphAttributes.justification;\n  var offset = 0;\n\n  if (oldAlignment === Justification.LEFT) {\n    if (newAlignment === Justification.CENTER) {\n      offset = width * 0.5;\n    }\n    if (newAlignment === Justification.RIGHT) {\n      offset = width;\n    }\n  }\n  if (oldAlignment === Justification.CENTER) {\n    if (newAlignment === Justification.LEFT) {\n      offset = - width * 0.5;\n    }\n    if (newAlignment === Justification.CENTER) {\n      offset = width * 0.5;\n    }\n  }\n  if (oldAlignment === Justification.RIGHT) {\n    if (newAlignment === Justification.LEFT) {\n      offset = - width;\n    }\n    if (newAlignment === Justification.CENTER) {\n      offset = - width * 0.5;\n    }\n  }\n\n  textOnPoint.paragraphs[0].paragraphAttributes.justification = newAlignment;\n  textOnPoint.translate(offset, 0);\n}\n";

	var realignAxes = "// Sets the alignment for the label text on axes\n// As most of it comes in left-aligned\nrealignAxes = function(opts) {\n\n  // Center-align all x tick labels\n  if (opts.chartType !== 'bar') {\n    var xAxis = querySelector(opts.name + ' X_axis Tick_labels');\n    var xTickLabels = xAxis.pageItems;\n    Array.prototype.forEach.call(xTickLabels, realignAxisLabel('center'));\n  }\n\n  // Right-align all y tick labels\n  // except for the suffix\n  var yAxis;\n  if(opts.chartType === 'bar' && opts.horizontalBarType!=='normal') {\n    yAxis = querySelector(opts.name + ' Data_labels Data_label');\n  } else {\n    yAxis = querySelector(opts.name + ' Y_axis Tick_labels');\n  }\n\n  var yTickLabels = Array.prototype.filter.call(yAxis.pageItems, function(label) {\n    return label.typename !== 'GroupItem';\n  });\n  yTickLabels.forEach(realignAxisLabel('right'));\n}\n\nfunction realignAxisLabel(alignment) {\n  return function (item) {\n    if (item.typename === 'GroupItem' || item.typename === 'PathItem') {\n      realignTextPoint({\n        item: item.pageItems[0],\n        alignment: alignment\n      });\n    } else {\n      realignTextPoint({\n        item: item,\n        alignment: alignment\n      });\n    }\n  }\n}\n";

	var getAllPageItems = "/*\nA group's `pageItems` only contains the top-level.\nThis fetches every element in the group and returns it as a flat array.\n*/\ngetAllPageItems = function(array) {\n    var result = [];\n    Array.prototype.forEach.call(array, function (a) {\n        result.push(a);\n        if (a.pageItems && a.pageItems.length > 0) {\n            result = result.concat(getAllPageItems(a.pageItems));\n        }\n    });\n    return result;\n}\n";

	var querySelector = "// A utility for selecting items based on their layer name/ID\n// Note: Spaces in layer names must be replaced with underscores\n// e.g. var item = querySelector('Chart X_axis');\nquerySelector = function(queryString) {\n  try {\n    return querySelectorAll(queryString)[0];\n  } catch (e) {\n    throw(\"querySelector did not match any items: \" + queryString);\n  }\n}\n\nquerySelectorAll = function(queryString) {\n  // We'll loop through this list like a DOM selector\n  // e.g. `querySelectorAll('Y_axis Tick_labels')` means find `Tick_labels` within `Y_axis`\n  var ids = queryString.split(' ').map(function(id) {\n    return id.replace(/_/g,' ');\n  });\n\n  // Start with the active layer only.\n  // Searching all layers at once can cause Illustrator to crash if there are a lot of objects in the document.\n  var selected = [app.activeDocument.activeLayer];\n  try {\n    ids.forEach(function(id) {\n      // Find every object on the page with a matching name,\n      // then update the `selected` object to go deeper\n      selected = getAllPageItems(selected).filter(function(item) {\n        return item.name === id;\n      });\n    });\n  } catch (err) {\n    throw(\"querySelectorAll did not match any items: \" + queryString);\n  }\n  if (selected === app.activeDocument.activeLayer) {\n    throw(\"querySelectorAll did not match any items: \" + queryString);\n  }\n  return selected;\n}\n";

	var applyTypeStyles = "var styleDict = [{\n  name: 'Dek',\n  paragraphStyle: 'Dek I  (8.4)'\n}, {\n  name: 'Chart_title',\n  characterStyle: 'Title, Annotation, Label  (8.4 Medium)'\n}, {\n  name: 'Source',\n  paragraphStyle: 'Note / source / byline'\n}, {\n  name: 'Note',\n  paragraphStyle: 'Note / source / byline'\n},{\n  name: 'Y_axis Tick_labels',\n  children: true,\n  characterStyle: 'X, Y  AXIS / data'\n}, {\n  name: 'X_axis Tick_labels X_Label',\n  children: true,\n  paragraphStyle: 'X, Y  AXIS / data'\n}, {\n  name: 'X_axis Tick_labels',\n  children: true,\n  characterStyle: 'X, Y  AXIS / data'\n}, {\n  name: 'Legend_item_label',\n  children: true,\n  characterStyle: 'Annotation, Label   (7.5 light)'\n},\n// {\n//   name: 'Bar_labels Tick_labels',\n//   children: true,\n//   characterStyle: 'Annotation, Label   (7.5 medium)'\n// },\n{\n  name: 'Bar_labels',\n  children: true,\n  characterStyle: 'Annotation, Label   (7.5 medium)'\n}, {\n  name: 'Label',\n  children: true,\n  characterStyle: 'Annotation, Label   (7.5 light)'\n}, {\n  name: 'Label Text',\n  children: true,\n  characterStyle: 'Annotation, Label   (7.5 light)'\n}, {\n  name: 'Horizontal_annotations',\n  children: true,\n  characterStyle: 'Annotation, Label   (7.5 light)'\n},\n//I was hoping this will set bolding to annotation, but it didn't work.\n// {\n//   name: 'Annotations_item_strong',\n//   children: false,\n//   characterStyle: 'Annotation, Label   (7.5 medium)'\n// },\n {\n  name: 'Data_labels Data_label',\n  children: true,\n  characterStyle: 'Annotation, Label   (7.5 light)'\n},{\n  name: 'Plot_band_label',\n  characterStyle: 'X, Y  AXIS / data'\n},{\n  name: 'Title',\n  characterStyle: 'X, Y  AXIS / data'\n}];\n\napplyTypeStyles = function(opts) {\n\n  var chart = querySelector(opts.name);\n  var chartOldPosition = chart.position;\n  realignAxes(opts);\n\n  var noneCharacterStyle = app.activeDocument.characterStyles[0];\n  var noneParagraphStyle = app.activeDocument.paragraphStyles[0];\n  styleDict.forEach(function(style) {\n    var characterStyle = null;\n    if (style.characterStyle) {\n      try {\n        characterStyle = app.activeDocument.characterStyles.getByName(style.characterStyle);\n      } catch (e) {\n        throw('Unable to find character style \"' + style.characterStyle + '\" in document for ' + style.name );\n      }\n    }\n    var paragraphStyle = null;\n    if (style.paragraphStyle) {\n      try {\n        paragraphStyle = app.activeDocument.paragraphStyles.getByName(style.paragraphStyle);\n      } catch (e) {\n        throw('Unable to find paragraph style \"' + style.paragraphStyle + '\" in document for ' + style.name );\n      }\n    }\n    var items = querySelectorAll(opts.name + ' ' + style.name);\n    if (!items || items.length === 0) {\n      // skip it, not present in current chart\n      return;\n    }\n    items.forEach(function(item) {\n      if (style.children) {\n        Array.prototype.forEach.call(item.textFrames, function(textFrame) {\n          applyStyles(textFrame, characterStyle, paragraphStyle);\n        });\n      } else {\n        applyStyles(item, characterStyle, paragraphStyle);\n      }\n    });\n\n  });\n\n  // Move chart to the left, as the y axis tick labels are no logner sticking out.\n  chart.position = chartOldPosition;\n}\n\nfunction applyStyles(item, characterStyle, paragraphStyle) {\n  if (characterStyle) {\n    characterStyle.applyTo(item.textRange, true);\n  }\n  if (paragraphStyle) {\n    var justification = item.textRange.paragraphAttributes.justification;\n    paragraphStyle.applyTo(item.textRange, true);\n    item.textRange.paragraphAttributes.justification = justification;\n  }\n}\n";

	var checkAITemplate = "// Test to see if we're in the print or ai2html template\n// By checking to see if a color swatch named 'Blue 1' exists\ncheckAITemplate = function() {\n  try {\n    app.activeDocument.spots.getByName('Blue 1')\n  } catch (err) {\n    return false;\n  }\n  return true;\n}\n";

	var writeDataToElement = "writeDataToElement = function(opts) {\n  var group = querySelector(opts.query);\n  group.note = JSON.stringify(opts.data);\n}\n";

	var readDataFromSelection = "readDataFromSelection = function() {\n  var docSelection = app.activeDocument.selection;\n  if (docSelection.length === 0) {\n    return false;\n  }\n  return docSelection[0].note;\n}\n";

	var extendScripts = [arrayPolyfills + jsonPolyfill + objectKeysPolyfill, placeFile, convertColor, convertGroupColors, getSizeOfSelection, textPointsToArea, realignTextPoint, realignAxes, getAllPageItems, querySelector, applyTypeStyles, checkAITemplate, writeDataToElement, readDataFromSelection]; // `runExtendScript` is a wrapper for running ExtendScripts, which is an asynchronous operation.
	// The 'script' is a string (like those imported above). It returns a standard ES6 Promise.

	function runExtendScript(script) {
	  return new Promise(function (res, rej) {
	    window.CSLibrary.evalScript(script, function (result) {
	      var errorOccurred = result.indexOf('Error') === 0;

	      if (errorOccurred) {
	        rej(result);
	      } else {
	        res(result);
	      }
	    });
	  });
	} // `runExtendScriptFunction` is a wrapper for running extendScript functions. It’s recommended over using `runExtendScript`,
	// because it has better error handling and can return data from the ExtendScript. It only supports one argument.
	// Use it like so:
	//
	//     runExtendScriptFunction('convertGroupColors', 'chart2').then(result => {
	//       console.log(result);
	//     }).catch(err => {
	//       console.error(error);
	//     });

	function runExtendScriptFunction(_x, _x2) {
	  return _runExtendScriptFunction.apply(this, arguments);
	}

	function _runExtendScriptFunction() {
	  _runExtendScriptFunction = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(functionName, args) {
	    var argsString, script, resultString;
	    return regenerator.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (args === undefined) {
	              args = {};
	            }

	            argsString = JSON.stringify(args);
	            script = "\n    var args = JSON.parse('".concat(argsString, "');\n    var result = ").concat(functionName, "(args);\n    if (result !== undefined) {\n      JSON.stringify(result);\n    } else {\n      false;\n    }\n  ");
	            resultString = '';
	            _context.prev = 4;
	            _context.next = 7;
	            return runExtendScript(script);

	          case 7:
	            resultString = _context.sent;
	            _context.next = 13;
	            break;

	          case 10:
	            _context.prev = 10;
	            _context.t0 = _context["catch"](4);
	            throw "Error while running extendScript function:\nFunction name: ".concat(functionName, "\nArguments: ").concat(argsString, "\n").concat(_context.t0);

	          case 13:
	            return _context.abrupt("return", JSON.parse(resultString));

	          case 14:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, null, [[4, 10]]);
	  }));
	  return _runExtendScriptFunction.apply(this, arguments);
	}

	// The extendScript functions are for additional conversion that isn't possible to do before placement.

	function placeFile$1(_x) {
	  return _placeFile.apply(this, arguments);
	}

	function _placeFile() {
	  _placeFile = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(filePath) {
	    var _ref,
	        _ref$artboardname,
	        _ref$convertToCMYK,
	        convertToCMYK,
	        _ref$optimizeText,
	        optimizeText,
	        _ref$scale,
	        scale,
	        _ref$width,
	        width,
	        _ref$chartType,
	        chartType,
	        _ref$horizontalBarTyp,
	        horizontalBarType,
	        _ref$xAxisLabelsWidth,
	        xAxisLabelsWidth,
	        _ref$position,
	        position,
	        _ref$data,
	        data,
	        isWSJTemplate,
	        chartName,
	        _args = arguments;

	    return regenerator.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref$artboardname = _ref.artboardname, _ref$convertToCMYK = _ref.convertToCMYK, convertToCMYK = _ref$convertToCMYK === void 0 ? false : _ref$convertToCMYK, _ref$optimizeText = _ref.optimizeText, optimizeText = _ref$optimizeText === void 0 ? false : _ref$optimizeText, _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? 1 : _ref$scale, _ref$width = _ref.width, width = _ref$width === void 0 ? null : _ref$width, _ref$chartType = _ref.chartType, chartType = _ref$chartType === void 0 ? null : _ref$chartType, _ref$horizontalBarTyp = _ref.horizontalBarType, horizontalBarType = _ref$horizontalBarTyp === void 0 ? null : _ref$horizontalBarTyp, _ref$xAxisLabelsWidth = _ref.xAxisLabelsWidth, xAxisLabelsWidth = _ref$xAxisLabelsWidth === void 0 ? null : _ref$xAxisLabelsWidth, _ref$position = _ref.position, position = _ref$position === void 0 ? {
	              x: 0,
	              y: 0
	            } : _ref$position, _ref$data = _ref.data, data = _ref$data === void 0 ? null : _ref$data;
	            _context.next = 3;
	            return runExtendScriptFunction("checkAITemplate");

	          case 3:
	            isWSJTemplate = _context.sent;

	            if (!((convertToCMYK || optimizeText) && isWSJTemplate === false)) {
	              _context.next = 7;
	              break;
	            }

	            alert("Placing charts from Illustrator only works in WSJ print or ai2html templates.\nDownload them here: https://drive.google.com/drive/folders/1Z8hztb0SY37r6BV0Q0i6NI6zNziPkev_");
	            return _context.abrupt("return");

	          case 7:
	            _context.prev = 7;
	            _context.next = 10;
	            return runExtendScriptFunction('placeFile', {
	              filePath: filePath,
	              scale: scale,
	              position: position
	            });

	          case 10:
	            chartName = _context.sent;

	            if (!convertToCMYK) {
	              _context.next = 14;
	              break;
	            }

	            _context.next = 14;
	            return runExtendScriptFunction('convertGroupColors', chartName);

	          case 14:
	            if (!data) {
	              _context.next = 17;
	              break;
	            }

	            _context.next = 17;
	            return runExtendScriptFunction('writeDataToElement', {
	              query: "".concat(chartName),
	              data: data
	            });

	          case 17:
	            if (!optimizeText) {
	              _context.next = 37;
	              break;
	            }

	            _context.next = 20;
	            return runExtendScriptFunction('textPointsToArea', {
	              query: "".concat(chartName, " Hed"),
	              width: width
	            });

	          case 20:
	            _context.next = 22;
	            return runExtendScriptFunction('textPointsToArea', {
	              query: "".concat(chartName, " Dek"),
	              width: width
	            });

	          case 22:
	            _context.next = 24;
	            return runExtendScriptFunction('textPointsToArea', {
	              query: "".concat(chartName, " Chart_title"),
	              width: width
	            });

	          case 24:
	            _context.next = 26;
	            return runExtendScriptFunction('textPointsToArea', {
	              query: "".concat(chartName, " Source"),
	              width: width
	            });

	          case 26:
	            _context.next = 28;
	            return runExtendScriptFunction('textPointsToArea', {
	              query: "".concat(chartName, " Note"),
	              width: width
	            });

	          case 28:
	            if (!(chartType === 'bar' && (horizontalBarType === 'normal' || horizontalBarType === 'noScaleAndLeft'))) {
	              _context.next = 31;
	              break;
	            }

	            _context.next = 31;
	            return runExtendScriptFunction('textPointsToArea', {
	              query: "".concat(chartName, " Bar_labels Tick_label"),
	              width: xAxisLabelsWidth
	            });

	          case 31:
	            _context.next = 33;
	            return runExtendScriptFunction('applyTypeStyles', {
	              name: chartName,
	              chartType: chartType,
	              horizontalBarType: horizontalBarType
	            });

	          case 33:
	            _context.next = 35;
	            return runExtendScriptFunction('textPointsToArea', {
	              query: "".concat(chartName, " Legend_item_label")
	            });

	          case 35:
	            _context.next = 37;
	            return runExtendScript("\n        querySelector('".concat(chartName, "').selected = true;\n      "));

	          case 37:
	            _context.next = 42;
	            break;

	          case 39:
	            _context.prev = 39;
	            _context.t0 = _context["catch"](7);
	            alert(_context.t0);

	          case 42:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, null, [[7, 39]]);
	  }));
	  return _placeFile.apply(this, arguments);
	}

	function clean(svgString) {
	  var chartInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    chartType: null
	  };
	  var chartType = chartInfo.chartType;
	  var horizontalBarType = chartInfo.horizontalBarType;
	  var isDotted = chartInfo.isDotted;
	  var txt = "<root1><root2>".concat(svgString, "</root2></root1>");

	  var _processMarkup = processMarkup(txt),
	      $$$1 = _processMarkup.$,
	      remove = _processMarkup.remove,
	      removeIfEmpty = _processMarkup.removeIfEmpty,
	      moveTo = _processMarkup.moveTo;

	  moveTo({
	    selectors: ['.highcharts-suffix'],
	    newParent: '.highcharts-yaxis-labels'
	  }); // Text element for legend labels can be either a group(if multiline) or text (one line).
	  // by attaching span to the text element, we ensure it always stays as a group, and styles applied to the group.

	  var legendLabels = $$$1('.highcharts-legend-item').find('text');
	  legendLabels.each(function (i, el) {
	    el.appendChild(document.createElement('tspan'));
	  }); //vertical annotations

	  var allLabels = $$$1('.highcharts-annotation-labels').find('.highcharts-label');
	  var allShapes = $$$1('.highcharts-annotation-shapes').children();
	  var allPaths = $$$1('.annotation-paths').children();
	  allLabels.each(function (i, label) {
	    var id = i + 1;
	    var shape = allShapes.get(i);
	    var path = allPaths.get(i);
	    $$$1('.highcharts-annotation').prepend("<g id=\"Annotation_".concat(id, "\"></g>"));
	    $$$1("#Annotation_".concat(id)).prepend(label);
	    $$$1("#Annotation_".concat(id)).prepend("<g id=\"Shape_".concat(id, "\"></g>"));
	    $$$1("#Shape_".concat(id)).prepend(shape);
	    $$$1("#Annotation_".concat(id)).prepend("<g id=\"Path_".concat(id, "\"></g>"));
	    $$$1("#Path_".concat(id)).prepend(path);
	  }); //horizontal annotations

	  var allHPaths = $$$1('.highcharts-plot-lines-5').children();
	  $$$1('.highcharts-plot-line-label').each(function (i, label) {
	    var path = allHPaths.get(i); //wanted to sort horiz ann as: annotation 1, annotation 2, etc.. however weren't able to apply proper styles bc of 'id'.
	    // $('.highcharts-plot-lines-5').prepend(`<g id="H_Annotation_${id}"></g>`);
	    // $(`#H_Annotation_${id}`).prepend(label);
	    // $(`#H_Annotation_${id}`).prepend(path);
	    // $('.highcharts-plot-lines-5').prepend(`<g id="H_Annotation_${id}"></g>`);

	    $$$1('.highcharts-plot-lines-5').prepend(label);
	    $$$1('.highcharts-plot-lines-5').prepend(path);
	  });

	  if (chartType === 'scatter') {
	    $$$1('.highcharts-series-group').prepend("<g id=\"Scatter_data\"></g>");
	    moveTo({
	      selectors: ['.highcharts-markers', '.highcharts-series'],
	      newParent: '#Scatter_data'
	    });
	    $$$1('.highcharts-yaxis text').attr('id', 'Title');
	    $$$1('.highcharts-xaxis text').attr('id', 'Title');
	    $$$1('#Title').each(function () {
	      var $element = $$$1(this);
	      $element.text($element.text());
	    });
	    moveTo({
	      selectors: ['#Title tspan'],
	      newParent: '#Title'
	    });
	  }

	  chartType === 'column' || chartType === 'bar' || chartType === 'area' ? $$$1('.highcharts-series-group').append("<g id=\"Baseline\"></g>") : $$$1('.highcharts-series-group').prepend("<g id=\"Baseline\"></g>");
	  moveTo({
	    selectors: [chartType === 'bar' && horizontalBarType !== 'normal' ? ".highcharts-yaxis-grid .highcharts-grid-line:first-child" : '.zero-line'],
	    newParent: '#Baseline'
	  });

	  if (chartType === 'bar' && horizontalBarType !== 'normal') {
	    $$$1('.highcharts-series-group').append("<g id=\"Data_labels\"></g>");
	    moveTo({
	      selectors: ['.highcharts-data-labels'],
	      newParent: '#Data_labels'
	    });
	  } else {
	    if (chartType === 'area') {
	      $$$1('.highcharts-series-group').append("<g id=\"Y_axis\"></g>");
	    } else {
	      $$$1('.highcharts-series-group').prepend("<g id=\"Y_axis\"></g>");
	    }

	    moveTo({
	      selectors: [chartType === 'scatter' ? '.highcharts-yaxis text' : '.highcharts-yaxis', '.highcharts-yaxis-labels', '.highcharts-yaxis-grid'],
	      newParent: '#Y_axis'
	    });
	  }

	  if (chartType === 'bar') {
	    $$$1('.highcharts-series-group').prepend("<g id=\"Bar_labels\"></g>");
	    remove('.highcharts-xaxis-grid');
	    moveTo({
	      selectors: [// '.highcharts-xaxis',
	      // '.highcharts-xaxis-labels'
	      '.highcharts-xaxis-labels text'],
	      newParent: '#Bar_labels'
	    });
	  } else if (chartType === 'scatter') {
	    $$$1('.highcharts-series-group').prepend("<g id=\"X_axis\"></g>");
	    moveTo({
	      selectors: ['.highcharts-xaxis text', '.highcharts-xaxis-labels', '.highcharts-xaxis-grid'],
	      newParent: '#X_axis'
	    }); // simplify x tick markup

	    $$$1('#X_axis text').each(function () {
	      var $element = $$$1(this);
	      $element.text($element.text());
	    });
	    moveTo({
	      selectors: ['#X_axis text tspan'],
	      newParent: '#X_axis text'
	    });
	    $$$1('.highcharts-xaxis-grid').attr('id', 'Ticks');
	    remove('.highcharts-xaxis');
	  } else {
	    $$$1('.highcharts-series-group').prepend("<g id=\"X_axis\"></g>");
	    remove('.highcharts-xaxis-grid');
	    moveTo({
	      selectors: ['.highcharts-xaxis', '.highcharts-xaxis-labels'],
	      newParent: '#X_axis'
	    });
	    var xAxisTextLabels = $$$1('.highcharts-xaxis-labels').find('text');
	    xAxisTextLabels.each(function (i, label) {
	      if ($$$1(label).children().length) {
	        $$$1(label).attr('id', "X_Label");
	      }
	    });
	  } // remove invisible fill from paths and lines


	  var elementsWithInvisibleFill = $$$1('line, path').filter(function (i, el) {
	    var fill = $$$1(el).attr('fill');
	    return fill === 'rgb(0, 0, 0)';
	  });
	  elementsWithInvisibleFill.attr('fill', 'none');
	  moveTo({
	    selectors: ['.highcharts-legend-item'],
	    newParent: '.highcharts-legend'
	  });
	  moveTo({
	    selectors: ['.title', '.dek', '.subdek', '.source', '.note'],
	    newParent: 'svg'
	  });
	  moveTo({
	    selectors: ['.highcharts-plot-band-label'],
	    newParent: '.highcharts-plot-bands-0'
	  });
	  ['recession', 'gray', 'champagne', 'dark-gray'].forEach(function (color) {
	    var bands = $$$1('.highcharts-plot-bands-0').find(".highcharts-plot-band--".concat(color));

	    if (bands.length) {
	      $$$1('.highcharts-plot-bands-0').prepend("<g id=".concat(color, "_group></g>"));
	      moveTo({
	        selectors: [".highcharts-plot-band--".concat(color)],
	        newParent: "#".concat(color, "_group")
	      });
	    }
	  });

	  if (chartType === 'column') {
	    var dataLabels = $$$1('.highcharts-data-labels').find('.highcharts-data-label');
	    dataLabels.each(function () {
	      if ($$$1(this).find('text')[0].textContent === '') {
	        $$$1(this).remove();
	      }
	    });
	    removeIfEmpty('.highcharts-data-labels');
	  }

	  remove('.highcharts-background');
	  remove('.highcharts-plot-background');
	  remove('.highcharts-plot-border');
	  remove('.highcharts-yaxis');
	  remove('desc');
	  remove('.highcharts-line-series .highcharts-tracker'); //defs needed for arrow annotation marker
	  // remove('defs');

	  remove('.highcharts-plot-lines-0');
	  remove('.highcharts-control-points');
	  removeIfEmpty('.highcharts-markers');

	  if (!isDotted) {
	    remove('clipPath');
	    $$$1('[clip-path]').attr('clip-path', null);
	  }

	  remove('.highcharts-legend-box');
	  removeIfEmpty('.highcharts-legend > g');
	  remove('.highcharts-suffix-box');
	  remove('.highcharts-axis-line');

	  if (chartType === 'bar') {
	    if (horizontalBarType !== 'normal') {
	      remove('.highcharts-label-box');
	      remove('.highcharts-yaxis-labels');
	      remove('.highcharts-yaxis-grid');
	    }

	    remove('.highcharts-label-box');
	  }

	  remove('.titleGroup');
	  remove('.dekGroup');
	  remove('.subdekGroup');
	  remove('.sourceGroup');
	  remove('.noteGroup');
	  remove('.credits');
	  remove('.headings');
	  remove('.highcharts-annotation-label-box');
	  remove('.highcharts-annotation-labels');
	  remove('.highcharts-annotation-shapes');
	  remove('.annotation-paths');
	  idMap.forEach(function (d) {
	    $$$1(d.selector).attr('id', d.id);
	  });
	  return $$$1('root2').html();
	}
	var idMap = [{
	  selector: '.highcharts-series',
	  id: 'Data'
	}, {
	  selector: '.highcharts-series-group',
	  id: 'Chart'
	}, {
	  selector: '.highcharts-djchart',
	  id: 'Chart_items'
	}, {
	  selector: '.highcharts-xaxis',
	  id: 'Ticks'
	}, {
	  selector: '.highcharts-xaxis-labels',
	  id: 'Tick_labels'
	}, // {
	//   selector: '.highcharts-xaxis-labels text',
	//   id: 'Tick_labels'
	// },
	{
	  selector: '#Bar_labels text',
	  id: 'Tick_label'
	}, // {
	//   selector: '#Bar_labels text tspan',
	//   id: 'Tick_labels'
	// },
	{
	  selector: '.highcharts-yaxis-grid',
	  id: 'Ticks'
	}, {
	  selector: '.highcharts-yaxis-labels',
	  id: 'Tick_labels'
	}, {
	  selector: '.highcharts-yaxis-labels text',
	  id: 'Tick_labels'
	}, {
	  selector: '.highcharts-data-labels',
	  id: 'Labels'
	}, {
	  selector: '.highcharts-data-label',
	  id: 'Data_label'
	}, {
	  selector: '.subdek',
	  id: 'Dek'
	}, {
	  selector: '.subdek--bold',
	  id: 'Chart_title'
	}, {
	  selector: '.dek',
	  id: 'Dek'
	}, {
	  selector: '.title',
	  id: 'Hed'
	}, {
	  selector: '.source',
	  id: 'Source'
	}, {
	  selector: '.note',
	  id: 'Note'
	}, {
	  selector: '.highcharts-markers',
	  id: 'Data_point_markers'
	}, {
	  selector: '.highcharts-legend',
	  id: 'Legend'
	}, {
	  selector: '.highcharts-legend-item',
	  id: 'Legend_item'
	}, {
	  selector: '.highcharts-legend-item text',
	  id: 'Legend_item_label'
	}, {
	  selector: '.highcharts-legend-item path',
	  id: 'Legend_item_chip'
	}, {
	  selector: '.highcharts-annotation',
	  id: 'Annotations'
	}, {
	  selector: '.highcharts-annotation-label',
	  id: 'Label'
	}, {
	  selector: '.highcharts-annotation-label text',
	  id: 'Text'
	}, {
	  selector: '.highcharts-plot-lines-5',
	  id: 'Horizontal_annotations'
	}, {
	  selector: '.highcharts-plot-line-label',
	  id: 'Text'
	}, {
	  selector: '.highcharts-plot-band-label',
	  id: 'Plot_band_label'
	}, {
	  selector: '.highcharts-plot-bands-0',
	  id: 'Plot_bands'
	} //my attempt to give an id to bolded annotations.
	// {
	//   selector:'.highcharts-annotation-label text .highcharts-strong',
	//   id: 'Annotations_item_strong'
	// }
	];

	var processMarkup = function processMarkup(txt) {
	  var jQueryObject = $(txt);

	  var select = function select(selector) {
	    return jQueryObject.find(selector);
	  };

	  select.html = function (selector) {
	    if (selector) {
	      return $('<div>').append(jQueryObject.find(selector).clone()).html();
	    }

	    return $('<div>').append(jQueryObject.clone()).html();
	  };

	  var moveTo = function moveTo(_ref) {
	    var selectors = _ref.selectors,
	        newParent = _ref.newParent;
	    var elements = selectors.map(function (s) {
	      return select.html(s);
	    });
	    selectors.forEach(function (s) {
	      return select(s).remove();
	    });
	    select(newParent).append(elements.join(''));
	  };

	  var remove = function remove(selector) {
	    select(selector).remove();
	  };

	  var removeIfEmpty = function removeIfEmpty(selector) {
	    var el = select(selector);

	    if (el[0] && el[0].children.length === 0) {
	      el.remove();
	    }
	  };

	  return {
	    $: select,
	    moveTo: moveTo,
	    remove: remove,
	    removeIfEmpty: removeIfEmpty
	  };
	};

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

	function check() {
	  return !!window.__adobe_cep__;
	} // This function needs to be run once, in order to load in Adobe-specific global variables.
	// In theory, it should be safe to run more than once.
	// It also uses the `check` function to make sure it doesn’t try to run the setup in a normal browser.

	function setup() {
	  if (check() && !window.CSLibrary) {
	    window.CSInterface = loadCSInterface();
	    window.CSLibrary = new CSInterface();
	  }

	  if (check()) {
	    return Promise.all(extendScripts.map(runExtendScript)).catch(function (err) {
	      console.error(err);
	    });
	  }
	} // Takes an SVG string, then when the resulting function is run, places the file in Illustrator.

	function place(svgData, opts) {
	  var timestamp = Date.now();
	  var file = saveSvg(svgData, "chart-".concat(timestamp, ".svg"));
	  return placeFile$1(file, opts);
	} // If something is selected, returns an object: {x, y, width, height}
	// If no selection, returns false

	function getSizeOfSelection$1() {
	  return _getSizeOfSelection.apply(this, arguments);
	} // Takes an SVG string and replaces the current selection

	function _getSizeOfSelection() {
	  _getSizeOfSelection = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
	    return regenerator.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return runExtendScriptFunction("getSizeOfSelection");

	          case 2:
	            return _context.abrupt("return", _context.sent);

	          case 3:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee);
	  }));
	  return _getSizeOfSelection.apply(this, arguments);
	}

	function replace(_x, _x2) {
	  return _replace.apply(this, arguments);
	} // Returns any JSON stored stored within selected object's note field
	// If no selection, returns false

	function _replace() {
	  _replace = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(svgData, opts) {
	    var position;
	    return regenerator.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return getSizeOfSelection$1();

	          case 2:
	            _context2.t0 = _context2.sent;

	            if (_context2.t0) {
	              _context2.next = 5;
	              break;
	            }

	            _context2.t0 = undefined;

	          case 5:
	            position = _context2.t0;
	            _context2.next = 8;
	            return runExtendScript("\n    Array.prototype.forEach.call(app.activeDocument.selection, function(item) {\n      item.remove()\n    });\n  ");

	          case 8:
	            return _context2.abrupt("return", place(svgData, _objectSpread({
	              position: position
	            }, opts)));

	          case 9:
	          case "end":
	            return _context2.stop();
	        }
	      }
	    }, _callee2);
	  }));
	  return _replace.apply(this, arguments);
	}

	function readDataFromSelection$1() {
	  return _readDataFromSelection.apply(this, arguments);
	}

	function _readDataFromSelection() {
	  _readDataFromSelection = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
	    var data;
	    return regenerator.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return runExtendScriptFunction("readDataFromSelection");

	          case 2:
	            data = _context3.sent;
	            _context3.prev = 3;
	            return _context3.abrupt("return", JSON.parse(data));

	          case 7:
	            _context3.prev = 7;
	            _context3.t0 = _context3["catch"](3);
	            return _context3.abrupt("return", false);

	          case 10:
	          case "end":
	            return _context3.stop();
	        }
	      }
	    }, _callee3, null, [[3, 7]]);
	  }));
	  return _readDataFromSelection.apply(this, arguments);
	}

	exports.check = check;
	exports.setup = setup;
	exports.place = place;
	exports.getSizeOfSelection = getSizeOfSelection$1;
	exports.replace = replace;
	exports.readDataFromSelection = readDataFromSelection$1;
	exports.clean = clean;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
